import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
// Custom validator to prevent whitespace-only group names
export function noWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
  const isWhitespace = (control.value || '').trim().length === 0;
  return !isWhitespace ? null : { whitespace: true };
}
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { AssessRequestRaService } from 'src/app/assess-request-ra/assess-request-ra.service';
import { groupDataModel } from 'src/app/common/models/GroupDataModel';
import { recipeModel } from 'src/app/common/models/recipeDetailsModel';
import { REGULATORY_GROUPTABLE_COLUMNS, RELATED_RULE_TABLE_COLUMNS, SUBSTANCE_COLUMNS, BULK_INVALID_EXPORT_COLUMNS, BULK_UPLOAD_COLUMNS
} from 'src/app/common/models/tableColumns';
import { DataService } from 'src/app/common/services/data.service';
import { WorklistService } from 'src/app/worklist/worklist.service';
import { environment } from 'src/environments/environment';
import { ExportExcelButtonComponent } from 'src/app/common/components/export-excel-button/export-excel-button.component';
import { MsalService } from '@azure/msal-angular';

interface BulkUploadSummary {
  inputCount: number;
  validCount: number;
  invalidCount: number;
}

interface BulkUploadRow {
  purecode: string;
  sirId: string;
  inciName: string;
  cas: string;
  parentCAS: string;
  ins: string;
  synonyms: string;
  cfInput: string;
  cfData: string;
  cfDataFromSIR?: string;
  notifySers: boolean;
  rowStatus: 'Valid' | 'Invalid';
  apiIsValid: boolean;
  errorMessage: string;
  selected: boolean;
  invalidTemplateRow?: any;
}

interface BulkSubstanceTemplateData {
  [key: string]: any;
  Substance: any;
  ParentCASnumber: string;
  INSNumber: string;
  Synonyms: string;
  Comments: string;
  CFInputData: string;
  CFDataFromSIR: string;
  IsValid: boolean;
}

interface SubstanceTemplateModel {
  PureCode: string;
  SirId: string;
  Cas: string;
  Einecs: string;
  InciName: string;
  CFNumber: string;
  SubstanceName: string;
}

@Component({
  selector: 'app-regulatory-group-master',
  templateUrl: './regulatory-group-master.component.html',
  styleUrls: ['./regulatory-group-master.component.scss']
})
export class RegulatoryGroupMasterComponent implements OnInit {
  @ViewChild('bulkInvalidExportRef') bulkInvalidExportRef!: ExportExcelButtonComponent;
  @ViewChild('dtGroupTable') dtGroupTable: any;
  @ViewChild('dtSubstanceTable') dtSubstanceTable: any;
  overlayText = '';
  hideOverlay = true;
  star = 'fa fa-fw fa-search';
  loadingRegulatoryGroupMasterListMessage: any;
  createGroupTab = false;
  isEditbtnDisable = false;
  substanceData: any;
  checkedFlag: any;
  exportDialog = false;
  notifyGPCDialog = false;
  sentPureCodes = '';
  filteredRows: any = [];
  filteredDataDivision: any[] = [];
  filteredDataGroup: any[] = [];
  divisionData: any[] = [];
  groupsData: any[] = [];
  showRelatedRulesPopupForDelete = false;
  checkedPureCodes: string[] = [];
  selectedSirDetailsEdit: any[] = [];
  editNotifyGPC = false;
  notifyGPCDialogEdit = false;
  isButtonVisible = false;
  isSubstanceSelected = false;
  groupToEditData: any;
  isAllSubstanceChecked = false;
  groupToCreateData: any;
  sirIdsforSubstanceDetails: string[] = [];
  checkSelectedVal = '';
  disableLoader = false;
  deleteGroupResponseSuccess = false;
  division = '';
  group = '';
  isGroupSelected = false;
  deleteGroupConfPopup = false;
  groupColumns = REGULATORY_GROUPTABLE_COLUMNS;
  groupData: any[] = [];
  selectedRowData: any = [];
  editGroupNamePopup = false;
  substanceGroupData: any;
  groupForm!: FormGroup;
  isEditGroup = false;
  isCreateGroup = false;
  isUpdateGroupDetails = false;
  createdGroup: any[] = [];
  switchedPureCodes: string[] = [];
  switchedSirDetails: any[] = [];
  switchedSirDetailsEdit: any[] = [];
  switchedPureCodesEdit: string[] = [];
  selectedSirDetails: any[] = [];
  selectedDivision: any = '';
  selectedGroup = '';
  substanceColumns: any[] = [];
  addSubstanceDialogue = false;
  substanceAlreadyAddedMessage = '';
  searchIdentifierValue: any;
  searchIdentifier: any;
  masterSubstanceIdentifier = '';
  filteredSubstanceIdentifiers: string[] = [];
  subtanceIdentifier = ['Pure Code', 'INCI Name', 'CAS #', 'SIR ID', 'Substance Name'];
  searchResultsGroup: any[] = [];
  disablePureCode = false;
  radioRowIndex = null;
  loading = false;
  loadingMessage = 'Getting Regulatory Group Master Details';
  searchedSubstanceData: any[] = [];
  searchedSubstanceDataTemp: any[] = [];
  selectedRows: any[] = [];
  isEditSelectAllChecked = false;
  showRelatedRulesPopup = false;
  prepareRuleTableData: any[] = [];
  prepareRuleColumns: any[] = [];
  myWorklistTableColumns: any[] = [];
  workListData: any[] = [];
  selectedRowWorklist: any = null;
  selectedRowsEmail: any[] = [];
  showRelatedRequests = false;
  enableDelete = false;
  viewRuleBtnDisableFlag = true;
  addItemBtnDisableFlag = true;
  deleteRulePopup = false;
  deleteRuleComment = '';
  deleteGroupPopup = false;
  editGroupPopup = false;
  deleteGroupComment = '';
  showEmailConfirmationDialog = false;
  emailComments = '';
  groupMasterData: any;
  removeBtn = false;
  userDetails: any;
  isRA = false;
  isRnD = false;
  isSuperAdmin = false;
  isSuperAdminOrGlobalRA = false;
  isUserAuthToEditGrpName = true;
  updId = '';
  deleteGroupResponse: any;
  isGroupName = true;
  popupOverlayText: any;
  popupHideOverlay = true;
  warningTextOpen = false;
  tablewarningComment: any;
  commentRD = '';
  orrTextOpen = false;
  tableORRComment: any;
  bulkUploadDialog = false;
  filetype = '.xlsx';
  bulkUploadStatusDialog = false;
  bulkUploadResultDialog = false;
  bulkUploadPopupError = '';
  selectedBulkFileName = '';
  isBulkFileNameValid = false;
  showOnlyInvalidBulkRows = false;
  isBulkSelectAllChecked = false;
  bulkInvalidExportDownloaded = false;
  readonly bulkFileNamePattern = /^[A-Za-z0-9 _]+$/;
  bulkUploadSummary: BulkUploadSummary = {
    inputCount: 0,
    validCount: 0,
    invalidCount: 0
  };
  bulkUploadRows: BulkUploadRow[] = [];
  bulkUploadColumns = BULK_UPLOAD_COLUMNS;
  bulkInvalidExportColumns = BULK_INVALID_EXPORT_COLUMNS;
  bulkUploadPageSize = 25;
  openRowActionMenuKey = '';
  activeRowActionData: any = null;
  activeRowActionIndex = -1;
  rowActionMenuTop = 0;
  rowActionMenuLeft = 0;
  editLaunchedFromView = false;
  editViewBackContext: any = null;
  originalEditGroupName = '';
  constructor(
    private assessRequestRa: AssessRequestRaService,
    private dataServiceObj: DataService,
    private http: HttpClient,
    public matSnackBar: MatSnackBar,
    public formBuilder: FormBuilder,
    private worklistService: WorklistService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private msalService: MsalService
  ) { }

  ngOnInit() {
    this.createGroupTab = false;
    this.createGroupFormStructure();
    this.groupColumns = REGULATORY_GROUPTABLE_COLUMNS;
    this.substanceColumns = SUBSTANCE_COLUMNS;
    this.isSubstanceSelected = false;
    this.getUserBasedDivision();
    if (this.isSuperAdminOrGlobalRA) {
      this.isButtonVisible = true;
    } else {
      this.isButtonVisible = false;
    }

    // Check for back from view FIRST - before getDivisonData() interferes
    const queryFromView = String(this.route && this.route.snapshot && this.route.snapshot.queryParams ? (this.route.snapshot.queryParams['fromView'] || '') : '').trim().toLowerCase();
    const queryDivision = String(this.route && this.route.snapshot && this.route.snapshot.queryParams ? (this.route.snapshot.queryParams['division'] || '') : '').trim();
    if (queryFromView === 'true' && queryDivision) {
      this.clearTransientNavigationQueryParams();
      this.division = queryDivision;
      this.group = '';
      this.selectedGroup = '';
      this.selectedDivision = this.buildDivisionSelection(queryDivision);
      this.groupForm.patchValue({
        UPDFullText: queryDivision,
        selectedDivision: this.selectedDivision
      });
      this.isGroupName = false;
      this.viewRuleBtnDisableFlag = false;
      this.createGroupTab = false;
      this.addSubstanceDialogue = false;
      this.isUpdateGroupDetails = false;
      this.radioRowIndex = null;
      this.selectedRowData = [];
      this.resetGroupListFilters();
      // Keep division autocomplete data available after returning from view.
      this.getDivisonData();
      // Load groups immediately with loader (same as edit page back)
      this.getGroups(true, true);
      return; // EXIT early - skip getDivisonData() to avoid loader interference
    }

    this.getDivisonData();
    this.prepareRuleColumns = RELATED_RULE_TABLE_COLUMNS;
    this.getWorklistColumns();

    // Edit from view page should trigger API first, then open edit UI.
    const queryEditFromView = String(this.route && this.route.snapshot && this.route.snapshot.queryParams
      ? (this.route.snapshot.queryParams['editFromView'] || '')
      : '').trim().toLowerCase();
    const queryEditDivision = String(this.route && this.route.snapshot && this.route.snapshot.queryParams
      ? (this.route.snapshot.queryParams['division'] || '')
      : '').trim();
    const queryEditGroupId = String(this.route && this.route.snapshot && this.route.snapshot.queryParams
      ? (this.route.snapshot.queryParams['groupId'] || '')
      : '').trim();
    const queryEditGroupName = String(this.route && this.route.snapshot && this.route.snapshot.queryParams
      ? (this.route.snapshot.queryParams['groupName'] || '')
      : '').trim();
    const queryEditGroupType = String(this.route && this.route.snapshot && this.route.snapshot.queryParams
      ? (this.route.snapshot.queryParams['groupType'] || 'Regulatory Group')
      : 'Regulatory Group').trim();

    if (queryEditFromView === 'true' && queryEditGroupName) {
      this.clearTransientNavigationQueryParams();

      // Initialize substanceGroupData early so editGroup() won't fail
      this.substanceGroupData = {
        groupId: queryEditGroupId,
        groupName: queryEditGroupName,
        groupType: queryEditGroupType || 'Regulatory Group',
        substanceData: []
      };

      // Set flags for back navigation tracking
      this.editLaunchedFromView = true;
      this.editViewBackContext = {
        division: queryEditDivision
      };

      if (queryEditDivision) {
        this.division = queryEditDivision;
        this.selectedDivision = this.buildDivisionSelection(queryEditDivision);
        this.groupForm.patchValue({
          UPDFullText: queryEditDivision,
          selectedDivision: this.selectedDivision
        });
        this.getGroupData();
      }

      // Show edit form immediately, then fetch fresh data
      this.editGroup();

      // Fetch fresh data from API
      this.fetchAndEditGroup({
        groupId: queryEditGroupId,
        groupName: queryEditGroupName,
        groupType: queryEditGroupType
      });
      return;
    }

  }

  private resetGroupListFilters() {
    this.filteredRows = [];
    this.masterSubstanceIdentifier = '';
    for (const val of this.groupColumns) {
      if (val.field !== 'check') {
        const colname = val.field + '_val';
        const element = document.getElementById(colname) as HTMLInputElement;
        if (element && element.value) {
          element.value = '';
        }
      }
    }
  }

  private openEditGroupFromContext(editContext: any, viewBackContext?: any) {
    const rows = Array.isArray(editContext.substanceTableData) ? editContext.substanceTableData : [];
    const mappedRows = rows.map((row: any) => ({
      sirId: row.sirId || row.substanceId || '',
      purecode: row.purecode || row.pureCode || '',
      substanceName: this.changeToTitleCase(row.substanceName || row.synonyms || ''),
      cas: row.cas || '',
      parentCAS: row.parentCAS || row.parentCas || '',
      inciName: row.inciName || '',
      ins: row.ins || '',
      cfInput: row.cfInput || row.cfInputData || row.CFInputData || '',
      cfDetails: row.cfDetails || [],
      cfdata: row.cfdata || row.cfData || '',
      einecs: row.einecs || '',
      synonyms: row.synonyms || row.substanceName || '',
      createdbyuser: row.createdbyuser || ''
    }));

    this.division = editContext.division || this.division;
    this.editLaunchedFromView = true;
    this.editViewBackContext = viewBackContext || null;
    this.substanceGroupData = {
      groupId: editContext.groupId,
      groupName: editContext.groupName || '',
      groupType: editContext.groupType || 'Regulatory Group',
      substanceData: mappedRows
    };

    Object.assign(groupDataModel, this.substanceGroupData);
    this.dataServiceObj.setSelectedGroup(this.substanceGroupData);
    this.editGroup();
  }
  /* istanbul ignore next */
  getUserBasedDivision() {
    this.userDetails = JSON.parse(localStorage.getItem('userRolesPermissions') || '{}');
    if (!this.userDetails || !Array.isArray(this.userDetails.roles)) {
      this.isRA = false;
      this.isRnD = false;
      this.isSuperAdmin = false;
      this.isSuperAdminOrGlobalRA = false;
      this.isUserAuthToEditGrpName = false;
      return;
    }
    const roles = this.userDetails.roles;
    const normalizedUpdId = this.updId !== undefined && this.updId !== null ? String(this.updId).trim() : '';

    this.isSuperAdmin = false;
    this.isSuperAdminOrGlobalRA = false;
    this.isUserAuthToEditGrpName = false;
    this.isRA = false;
    this.isRnD = false;

    roles.forEach((c: any) => {
      if (!c) {
        return;
      }

      if (c.roleId === 150) {
        this.isSuperAdmin = true;
        this.isSuperAdminOrGlobalRA = true;
      }

      if (c.roleId === 140) {
        const roleDivisionId = c.tfc && c.tfc.tfcId !== undefined && c.tfc.tfcId !== null
          ? String(c.tfc.tfcId).trim()
          : '';

        // Allow division selection before UPD is resolved; enforce UPD match once available.
        if (!normalizedUpdId || roleDivisionId === normalizedUpdId) {
          this.isSuperAdminOrGlobalRA = true;
        }
      }

      if (c.roleId === 140 || c.roleId === 130 || c.roleId === 160 || c.roleId === 170) {
        this.isRA = true;
      }

      if (c.roleId === 120 || c.roleId === 110 || c.roleId === 170) {
        this.isRnD = true;
      }
    });

    this.isUserAuthToEditGrpName = this.isSuperAdminOrGlobalRA;
  }
  createGroup() {
    if (!this.isSuperAdmin) {
      return;
    }
    this.selectedRows = [];
    this.isCreateGroup = true;
    this.isUpdateGroupDetails = false;
    this.createGroupTab = true;
    this.addSubstanceDialogue = false;
    this.isEditGroup = false;
    this.createdGroup = [];
    this.isEditbtnDisable = false;
    const ele = document.getElementById('echeck') as HTMLInputElement;
    if (ele) {
      ele.checked = false;
    }
  }
  addSubstanceMethod() {
    this.searchIdentifier = null;
    this.searchIdentifierValue = null;
    this.searchResultsGroup = [];
    this.disablePureCode = false;
    this.selectedRowData = [];
    this.searchedSubstanceData = [];
    this.searchedSubstanceDataTemp = [];
    this.switchedPureCodes = [];
    this.substanceAlreadyAddedMessage = '';
    this.addSubstanceDialogue = true;
    this.isAllSubstanceChecked = false;
    this.isSubstanceSelected = false;
    this.switchedSirDetails = [];
    this.switchedPureCodes = [];
  }

  openBulkUploadDialog() {
    this.resetBulkUploadState();
    this.bulkUploadDialog = true;
  }

  onBulkFileSelect(event: any) {
    const selectedFile = event && event.files && event.files.length ? event.files[0] : null;
    this.selectedBulkFileName = selectedFile ? selectedFile.name : '';
    const isNameValid = this.validateBulkFileName(this.selectedBulkFileName, false);
    const isTypeValid = this.validateBulkFileType(this.selectedBulkFileName, false);
    this.isBulkFileNameValid = isNameValid && isTypeValid;
  }

  onBulkFileClear() {
    this.selectedBulkFileName = '';
    this.isBulkFileNameValid = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target && (target.closest('.group-row-menu-trigger') || target.closest('.group-row-actions-menu'))) {
      return;
    }
    this.openRowActionMenuKey = '';
    this.activeRowActionData = null;
    this.activeRowActionIndex = -1;
  }

  toggleGroupActionMenu(event: any, rowData: any, rowIndex: number) {
    event.stopPropagation();
    this.onGroupSelect(event, rowData, rowIndex);
    const currentKey = this.getRowActionMenuKey(rowData, rowIndex);

    if (this.openRowActionMenuKey === currentKey) {
      this.openRowActionMenuKey = '';
      this.activeRowActionData = null;
      this.activeRowActionIndex = -1;
      return;
    }

    const buttonEl = event.currentTarget as HTMLElement;
    const rect = buttonEl.getBoundingClientRect();
    const menuHeight = this.isSuperAdmin ? 100 : 44;
    const spaceBelow = window.innerHeight - rect.bottom;

    // Position below if enough space, otherwise above
    if (spaceBelow >= menuHeight) {
      this.rowActionMenuTop = rect.bottom + 2;
    } else {
      this.rowActionMenuTop = rect.top - menuHeight - 2;
    }

    this.rowActionMenuLeft = rect.left + 6;

    this.activeRowActionData = rowData;
    this.activeRowActionIndex = rowIndex;
    this.openRowActionMenuKey = currentKey;
  }

  closeGroupActionMenu() {
    this.openRowActionMenuKey = '';
    this.activeRowActionData = null;
    this.activeRowActionIndex = -1;
  }

  onGroupActionView(event: any, rowData: any, rowIndex: number) {
    event.stopPropagation();
    this.onGroupSelect(event, rowData, rowIndex);
    this.openRowActionMenuKey = '';
    this.activeRowActionData = null;
    this.activeRowActionIndex = -1;

    const groupId = String(rowData.groupId);
    this.router.navigate(['/administration/regulatory-group-master/view-group', groupId], {
      queryParams: {
        groupName: rowData.groupName || '',
        groupType: rowData.groupType || 'Regulatory Group',
        division: this.division || 'BPC'
      }
    });
  }

  onGroupActionEdit(event: any, rowData: any, rowIndex: number) {
    if (!this.isSuperAdmin) {
      this.closeGroupActionMenu();
      return;
    }
    event.stopPropagation();
    this.onGroupSelect(event, rowData, rowIndex);
    this.openRowActionMenuKey = '';
    this.activeRowActionData = null;
    this.activeRowActionIndex = -1;

    // Initialize substanceGroupData for 3-dot edit
    this.substanceGroupData = {
      groupId: rowData.groupId,
      groupName: rowData.groupName,
      groupType: rowData.groupType || 'Regulatory Group',
      substanceData: []
    };

    // Show edit form immediately
    this.editGroup();

    // Fetch fresh data from API
    this.fetchAndEditGroup(rowData);
  }

  onGroupActionDelete(event: any, rowData: any, rowIndex: number) {
    if (!this.isSuperAdmin) {
      this.closeGroupActionMenu();
      return;
    }
    event.stopPropagation();
    this.onGroupSelect(event, rowData, rowIndex);
    this.openRowActionMenuKey = '';
    this.activeRowActionData = null;
    this.activeRowActionIndex = -1;
    this.deleteGroupConfirmation();
  }

  private getRowActionMenuKey(rowData: any, rowIndex: number) {
    return `${rowData.groupId}_${rowIndex}`;
  }

  private navigateToViewGroup(groupData: any, substanceTableData: any[] = []) {
    const groupId = String(groupData && groupData.groupId ? groupData.groupId : '').trim();
    if (!groupId) {
      return;
    }

    this.router.navigate(['/administration/regulatory-group-master/view-group', groupId], {
      queryParams: {
        groupName: (groupData && groupData.groupName) || '',
        groupType: (groupData && groupData.groupType) || 'Regulatory Group',
        division: this.division || this.getSelectedDivisionName() || 'BPC'
      },
      state: {
        substanceTableData: Array.isArray(substanceTableData) ? substanceTableData : []
      }
    });
  }

  private mapGroupSubstancesForView(groupId: any) {
    return this.groupData
      .filter((item: any) => String(item.groupId) === String(groupId) && item.substanceName)
      .map((item: any) => ({
        pureCode: item.pureCode,
        sirId: item.substanceId,
        inciName: item.inciName,
        cas: item.cas,
        parentCAS: item.parentCAS,
        ins: item.ins,
        einecs: item.einecs,
        synonyms: this.changeToTitleCase(item.substanceName),
        cfInput: item.cfInput || '',
        cfData: item.cfData,
        notifySers: false,
        notifySir: false
      }));
  }
  // onBulkUpload(event: any, fileuploadForm: any) {
  onBulkUpload(event: any, fileuploadForm: any) {
    const selectedFile = event && event.files && event.files.length ? event.files[0] : null;
    if (!selectedFile) {
      this.matSnackBar.open('Select a file to upload', 'close', {
        duration: 3900,
        panelClass: ['error']
      });
      return;
    }

    if (!this.validateBulkFileName(selectedFile.name, true) || !this.validateBulkFileType(selectedFile.name, true)) {
      return;
    }

    if (fileuploadForm) {
      fileuploadForm.clear();
    }

    this.loading = true;
    this.loadingMessage = 'Uploading Bulk Substances';

    const apiurl = environment.APIFAsTRule + '/bulksubstance/validatetemplate';
    const formData = new FormData();
    formData.append('file', selectedFile, selectedFile.name);

    const userDetails = JSON.parse(localStorage.getItem('userRolesPermissions') || '{}');
    this.getRefreshedAccessToken().then((bearerToken) => {
      let headerdata = new HttpHeaders({
        Authorization: 'Bearer ' + bearerToken,
        'X-FAST-AUTH-K': '6ee2a098-e2d6-4893-b8b4-18f01c9a67a1-6DB1487E-C741-4669-B8BB-9F34EE294EEF',
        'X-Requested-With': 'XMLHttpRequest'
      });
      if (userDetails && userDetails.userId !== undefined && userDetails.userId !== null) {
        headerdata = headerdata.set('userId', String(userDetails.userId));
      }

      this.http.post<any>(apiurl, formData, { headers: headerdata }).subscribe((response) => {
        const mappedResponse = this.mapBulkValidationApiResponse(response);
        this.handleBulkUploadResponse(mappedResponse);
        this.finishBulkUploadRequest(fileuploadForm);
      }, (error) => {
        const status = error && error.status ? ' (' + error.status + ')' : '';
        const message = error && error.status === 401
          ? 'You do not have permission to validate this template. Please contact FAsT support.'
          : this.getBulkUploadSaveErrorMessage(error, '');
        this.matSnackBar.open(message + status, 'close', {
          duration: 4500,
          panelClass: ['error']
        });
        this.finishBulkUploadRequest(fileuploadForm);
      });
    }).catch(() => {
      this.matSnackBar.open('Unable to validate bulk upload template.', 'close', {
        duration: 4500,
        panelClass: ['error']
      });
      this.finishBulkUploadRequest(fileuploadForm);
    });
  }

  private getRefreshedAccessToken(): Promise<string> {
    const fallbackToken = localStorage.getItem('Token') || localStorage.getItem('FunctionToken') || '';
    const account = this.msalService.instance.getActiveAccount() || this.msalService.instance.getAllAccounts()[0];
    if (!account) {
      return Promise.resolve(fallbackToken);
    }

    return this.msalService.instance.acquireTokenSilent({
      account,
      scopes: [environment.ImpersonationConfig]
    }).then((authResult: any) => {
      const accessToken = authResult && authResult.accessToken ? authResult.accessToken : fallbackToken;
      if (accessToken) {
        localStorage.setItem('Token', accessToken);
      }
      return accessToken;
    }).catch(() => fallbackToken);
  }

  finishBulkUploadRequest(fileuploadForm: any) {
    this.loading = false;
    this.loadingMessage = 'Loading...';
    if (fileuploadForm) {
      fileuploadForm.clear();
    }
    this.onBulkFileClear();
    this.bulkUploadDialog = false;
  }

  mapBulkValidationApiResponse(response: any) {
    const rows = this.getBulkValidationResponseRows(response);
    const mappedRows = rows.map((row) => this.mapBulkValidationApiRow(row));
    const validCount = mappedRows.filter((row) => row.rowStatus === 'Valid').length;
    const invalidCount = mappedRows.filter((row) => row.rowStatus === 'Invalid').length;
    const inputCount = mappedRows.length;

    return {
      inputCount,
      validCount,
      invalidCount,
      rows: mappedRows
    };
  }

  getBulkValidationResponseRows(response: any): BulkSubstanceTemplateData[] {
    if (!response) {
      return [];
    }
    if (Array.isArray(response)) {
      return response;
    }
    if (Array.isArray(response.rows)) {
      return response.rows;
    }
    if (Array.isArray(response.data)) {
      return response.data;
    }
    if (Array.isArray(response.result)) {
      return response.result;
    }
    return [];
  }

  mapBulkValidationApiRow(row: BulkSubstanceTemplateData): BulkUploadRow {
    const rowData: any = row || {};
    const substance = rowData && (rowData.Substance || rowData.substance) ? (rowData.Substance || rowData.substance) : null;
    const isValid = !!(rowData && (rowData.IsValid === true || rowData.isValid === true));
    const normalizedRowStatus = this.normalizeBulkRowStatus(isValid ? 'Valid' : 'Invalid');
    const purecode = this.getBulkApiFieldValue(substance, ['PURE Code ', 'PURE Code', 'Pure Code', 'pureCode']) || '';
    const sirId = this.getBulkApiFieldValue(substance, ['SIR ID', 'SirId', 'sirId']) || '';
    const inciName = this.getBulkApiFieldValue(substance, ['INCI Name', 'InciName', 'inciName']) || '';
    const cas = this.getBulkApiFieldValue(substance, ['CAS #', 'CAS#', 'cas']) || '';
    const parentCAS = this.getBulkApiFieldValue(row, ['ParentCASnumber', 'parentCASnumber', 'Parent CAS Number']) || '';
    const ins = this.getBulkApiFieldValue(row, ['INSNumber', 'insNumber', 'INS Number']) || '';
    const synonyms = this.getBulkApiFieldValue(row, ['Synonyms', 'synonyms'])
      || this.getBulkApiFieldValue(substance, ['Synonyms', 'synonyms', 'Substance name', 'Substance Name'])
      || '';
    const cfInput = this.getBulkApiFieldValue(row, ['CFInputData', 'cfInputData', 'CF Input Data']) || '';
    const cfDataFromSIR = this.getBulkApiFieldValue(row, ['CFDataFromSIR', 'cfDataFromSIR', 'CF Data From SIR']) || '';
    const cfData = this.getBulkApiFieldValue(row, ['CFData', 'cfData', 'CF Data'])
      || this.getBulkApiFieldValue(substance, ['CF', 'cf'])
      || '';
    const errorMessage = isValid
      ? ''
      : (this.getBulkApiFieldValue(row, ['Comments', 'comments', 'ErrorMessage', 'errorMessage', 'ValidationMessage', 'validationMessage', 'Reason', 'reason']) || 'Invalid data');

    return {
      purecode,
      sirId,
      inciName,
      cas,
      parentCAS,
      ins,
      synonyms,
      cfInput,
      cfData,
      cfDataFromSIR,
      notifySers: false,
      rowStatus: normalizedRowStatus,
      apiIsValid: isValid,
      errorMessage,
      selected: false,
      invalidTemplateRow: {
        'PURE Code': purecode,
        'SIR ID': sirId,
        'CAS #': cas,
        EINECS: this.getBulkApiFieldValue(substance, ['EINECS', 'Einecs', 'einecs']) || '',
        CF: this.getBulkApiFieldValue(substance, ['CF', 'cf']) || cfData,
        'INCI Name': inciName,
        'Substance name': this.getBulkApiFieldValue(substance, ['Substance name', 'Substance Name', 'substanceName']) || synonyms,
        Comments: errorMessage
      }
    };
  }

  normalizeBulkRowStatus(rowStatus: string) {
    return String(rowStatus || '').trim().toLowerCase() === 'invalid' ? 'Invalid' : 'Valid';
  }

  private normalizeBooleanFlag(value: any): boolean {
    if (value === true) {
      return true;
    }
    if (value === false || value === null || value === undefined) {
      return false;
    }

    const normalized = String(value).trim().toLowerCase();
    return normalized === 'y' || normalized === 'yes' || normalized === 'true' || normalized === '1';
  }

  isBulkRowInvalid(row: BulkUploadRow) {
    if (row && typeof row.apiIsValid === 'boolean') {
      return row.apiIsValid === false;
    }
    return this.normalizeBulkRowStatus(row && row.rowStatus) === 'Invalid';
  }

  isBulkRowValid(row: BulkUploadRow) {
    if (row && typeof row.apiIsValid === 'boolean') {
      return row.apiIsValid === true;
    }
    return this.normalizeBulkRowStatus(row && row.rowStatus) === 'Valid';
  }

  getBulkApiFieldValue(source: any, keys: string[]) {
    if (!source) {
      return '';
    }
    for (const key of keys) {
      if (source[key] !== undefined && source[key] !== null && source[key] !== '') {
        return String(source[key]).trim();
      }
    }
    return '';
  }


  validateBulkFileName(fileName: string, showError: boolean) {
    const nameWithoutExtension = (fileName || '').replace(/\.[^/.]+$/, '');
    const isValid = this.bulkFileNamePattern.test(nameWithoutExtension);
    if (!isValid && showError) {
      this.matSnackBar.open('Bulk upload file name can contain letters, numbers, spaces, hyphen, and underscore only', 'close', {
        duration: 5000,
        panelClass: ['error']
      });
    }
    return isValid;
  }

  validateBulkFileType(fileName: string, showError: boolean) {
    const isValid = !!fileName && fileName.toLowerCase().endsWith('.xlsx');
    if (!isValid && showError) {
      this.matSnackBar.open('Please upload only .xlsx file format', 'close', {
        duration: 5000,
        panelClass: ['error']
      });
    }
    return isValid;
  }

  handleBulkUploadResponse(response: any) {
    this.bulkUploadSummary = {
      inputCount: response && response.inputCount ? response.inputCount : 0,
      validCount: response && response.validCount ? response.validCount : 0,
      invalidCount: response && response.invalidCount ? response.invalidCount : 0
    };
    this.bulkUploadRows = [];
    const rows = (response && response.rows) ? response.rows : [];
    rows.forEach((row: any, index: number) => {
      const normalizedRowStatus = this.normalizeBulkRowStatus(row.rowStatus);
      this.bulkUploadRows.push({
        purecode: row.purecode,
        sirId: row.sirId,
        inciName: row.inciName,
        cas: row.cas,
        parentCAS: row.parentCAS,
        ins: row.ins,
        synonyms: row.synonyms,
        cfInput: row.cfInput,
        cfData: row.cfData,
        cfDataFromSIR: row.cfDataFromSIR || '',
        notifySers: !!row.notifySers,
        rowStatus: normalizedRowStatus,
        apiIsValid: typeof row.apiIsValid === 'boolean' ? row.apiIsValid : normalizedRowStatus === 'Valid',
        errorMessage: row.errorMessage || '',
        selected: false,
        invalidTemplateRow: row.invalidTemplateRow || null
      });
    });
    this.isBulkSelectAllChecked = false;
    this.showOnlyInvalidBulkRows = false;
    this.bulkUploadStatusDialog = true;
  }

  onBulkStatusContinue() {
    this.bulkUploadStatusDialog = false;
    this.bulkUploadResultDialog = true;
  }

  getBulkRowsForView() {
    // Result grid should always show only valid rows.
    return this.bulkUploadRows.filter(row => this.isBulkRowValid(row));
  }

  shouldShowBulkPaginator() {
    return this.getBulkRowsForView().length > this.bulkUploadPageSize;
  }

  toggleBulkInvalidRowsView() {
    this.showOnlyInvalidBulkRows = false;
    this.onBulkRowSelectionChange();

    if (this.bulkInvalidExportRef && this.getBulkInvalidRows().length > 0) {
      this.bulkInvalidExportDownloaded = true;
      setTimeout(() => {
        this.bulkInvalidExportRef.exportToExcel();
        this.onBulkRowSelectionChange();
      }, 0);
    }
  }

  onBulkRowSelectAll(event: any) {
    const isChecked = event && event.target && typeof event.target.checked === 'boolean'
      ? event.target.checked
      : (event && typeof event.checked === 'boolean' ? event.checked : !!this.isBulkSelectAllChecked);
    this.isBulkSelectAllChecked = isChecked;
    this.bulkUploadPopupError = '';
    this.getBulkRowsForView().forEach(row => {
      if (this.isBulkRowValid(row)) {
        row.selected = isChecked;
      }
    });
  }

  onBulkRowSelectionChange() {
    this.bulkUploadPopupError = '';
    const validRows = this.getBulkRowsForView().filter(row => this.isBulkRowValid(row));
    this.isBulkSelectAllChecked = validRows.length > 0 && validRows.every(row => row.selected);
  }

  getSelectedBulkValidRowsCount() {
    return this.bulkUploadRows.filter(row => row.selected && this.isBulkRowValid(row)).length;
  }

  canSaveBulkValidSubstances() {
    const hasSelectedValidRows = this.getSelectedBulkValidRowsCount() > 0;
    const requiresInvalidExport = this.bulkUploadSummary.invalidCount > 0;
    return hasSelectedValidRows && (!requiresInvalidExport || this.bulkInvalidExportDownloaded);
  }

  getSelectedBulkNotifyRowsCount() {
    return this.bulkUploadRows.filter(row => row.notifySers && this.isBulkRowValid(row)).length;
  }

  onBulkNotifySwitch(event: any, rowData: BulkUploadRow) {
    const isChecked = event && typeof event.checked === 'boolean' ? event.checked : !!rowData.notifySers;
    rowData.notifySers = isChecked;
    if (isChecked === true) {
      if (!this.checkedPureCodes.includes(rowData.purecode)) {
        this.checkedPureCodes.push(rowData.purecode);
      }
    } else {
      const index = this.checkedPureCodes.findIndex(d => d === rowData.purecode);
      if (index !== -1) {
        this.checkedPureCodes.splice(index, 1);
      }
    }
    this.syncBulkNotifySelections();
  }

  private syncBulkNotifySelections() {
    this.checkedPureCodes = Array.from(new Set(
      this.bulkUploadRows
        .filter((row) => row.notifySers && this.isBulkRowValid(row))
        .map((row) => row.purecode)
        .filter((code) => !!code)
    ));
  }

  notifyBulkSers() {
    const selectedNotifyRows = this.bulkUploadRows.filter(row => row.notifySers);
    if (selectedNotifyRows.length === 0) {
      this.matSnackBar.open('Select the Pure Codes', 'close', {
        duration: 3900,
        panelClass: ['error']
      });
      return;
    }

    const issueCategoryList = [
      { name: 'CAS#', value: 'CAS#' },
      { name: 'Parent CAS#', value: 'Parent CAS#' },
      { name: 'E#', value: 'E#' },
      { name: 'INS#', value: 'INS#' },
      { name: 'EINECS#', value: 'EINECS#' },
      { name: 'INCI', value: 'INCI' },
      { name: 'Synonym', value: 'Synonym' },
      { name: 'CF details', value: 'CF details' },
    ];

    this.switchedSirDetails = selectedNotifyRows.map((row) => ({
      purecode: row.purecode || '',
      sirId: row.sirId || '',
      inciName: row.inciName || '',
      pureDescription: row.synonyms || '',
      issueCategoryList,
      selectedIssueCategory: [],
      commentsToUser: ''
    }));

    this.switchedPureCodes = Array.from(new Set(
      selectedNotifyRows.map((row) => row.purecode).filter((code) => !!code)
    ));

    this.notifyGPCClicked(null, this.switchedSirDetails);
  }

  saveBulkValidSubstances() {
    this.bulkUploadPopupError = '';
    const validRowsToSave = this.bulkUploadRows.filter(row => row.selected && this.isBulkRowValid(row));
    if (validRowsToSave.length === 0) {
      this.matSnackBar.open('Select at least one valid substance to save', 'close', {
        duration: 3500,
        panelClass: ['error']
      });
      return;
    }

    const selectedSirIds = Array.from(new Set(validRowsToSave
      .map(row => row.sirId)
      .filter((sirId: string) => !!sirId && !sirId.includes('SIR ID Not found'))));

    if (selectedSirIds.length === 0) {
      this.matSnackBar.open('No valid SIR IDs found to save', 'close', {
        duration: 3500,
        panelClass: ['error']
      });
      return;
    }

    const substanceTableData = validRowsToSave
      .filter(row => !!row.sirId && !row.sirId.includes('SIR ID Not found'))
      .map(row => ({
        // Keep both key styles so edit and view tables can render immediately.
        pureCode: row.purecode || '',
        purecode: row.purecode || '',
        sirId: row.sirId || '',
        inciName: row.inciName || '',
        cas: row.cas || '',
        parentCAS: row.parentCAS || '',
        ins: row.ins || '',
        einecs: '',
        synonyms: row.synonyms || '',
        cfInput: (row as any).cfInputData || row.cfInput || '',
        cfInputData: (row as any).cfInputData || row.cfInput || '',
        cfData: row.cfData || '',
        cfdata: row.cfData || '',
        cfDataFromSIR: (row as any).cfDataFromSIR || '',
        notifySers: false,
        notifygpc: false,
        notifySir: false
      }));

    let apiurl;
    let data;
    this.loading = true;
    const bulkActionFromCreatePage = this.isCreateGroup && !this.isEditGroup;

    // Create-page bulk save uses dedicated bulk upload endpoint/payload.
    if (!this.isEditGroup && this.createdGroup.length === 0) {
      this.loadingMessage = 'Saving Group';
      apiurl = environment.APIFAsTRule + '/rules/bulkupload/substancegroup';
      this.groupToCreateData = this.groupForm.value;
      this.groupToCreateData.SubstanceIds = selectedSirIds;
      this.groupToCreateData.Substances = substanceTableData.map((row: any) => ({
        pureCode: row.pureCode || '',
        sirId: row.sirId || '',
        inciName: row.inciName || '',
        cas: row.cas || '',
        parentCAS: row.parentCAS || '',
        ins: row.ins || '',
        einecs: row.einecs || '',
        synonyms: row.synonyms || '',
        CFInputData: (row.cfInputData),
        CFDataFromSIR: row.cfDataFromSIR || '',
        CFData: (row.cfData),
        notifySers: false,
        notifySir: false
      }));
      data = this.groupToCreateData;
      this.assessRequestRa.postData(apiurl, data).subscribe((response) => {
        this.bulkUploadResultDialog = false;
        this.matSnackBar.open('Group created successfully', 'close', {
          duration: 3000,
          panelClass: ['success']
        });
        this.isEditGroup = false;
        this.isCreateGroup = true;
        this.isUpdateGroupDetails = false;
        this.oncloseDialog();
        this.substanceGroupData = {
          groupId: response.groupId,
          groupName: response.groupName,
          groupType: response.groupType,
          substanceData: substanceTableData
        };
        this.createdGroup = substanceTableData;

        this.loading = false;
        this.loadingMessage = 'Loading...';
        this.createGroupTab = true;
        this.navigateToViewGroup(this.substanceGroupData, substanceTableData);
      }, (error) => {
        this.loading = false;
        this.loadingMessage = 'Loading...';
        this.matSnackBar.dismiss();
        this.bulkUploadResultDialog = true;
        this.bulkUploadPopupError = this.getBulkUploadSaveErrorMessage(error, 'Unable to save bulk upload substances.');
        return false;
      });
    } else {
      this.loadingMessage = 'Updating Group';
      apiurl = environment.APIFAsTRule + '/rules/bulkupload/editsubstancegroup';
      this.groupToEditData = Object.assign({}, this.substanceGroupData);
      const mergedSirIds = new Set((this.createdGroup || []).map((item: any) => item.sirId));
      selectedSirIds.forEach((sirId) => mergedSirIds.add(sirId));
      this.groupToEditData.SubstanceIds = Array.from(mergedSirIds);
      this.groupToEditData.Substances = substanceTableData.map((row: any) => ({
        pureCode: row.pureCode || '',
        sirId: row.sirId || '',
        inciName: row.inciName || '',
        cas: row.cas || '',
        parentCAS: row.parentCAS || '',
        ins: row.ins || '',
        einecs: row.einecs || '',
        synonyms: row.synonyms || '',
        CFInputData: (row.cfInputData),
        CFDataFromSIR: row.cfDataFromSIR || '',
        CFData: (row.cfData),
        notifySers: false,
        notifySir: false
      }));
      delete this.groupToEditData.SubstanceTableData;
      delete this.groupToEditData.substanceData;

      data = this.groupToEditData;
      this.assessRequestRa.putData(apiurl, data).subscribe((response) => {
        this.bulkUploadResultDialog = false;
        this.matSnackBar.open('Group updated successfully', 'close', {
          duration: 3000,
          panelClass: ['success']
        });

        this.createdGroup = this.mergeSubstancesForEdit(this.createdGroup || [], substanceTableData || []);
        this.substanceGroupData = {
          ...(this.substanceGroupData || {}),
          substanceData: this.createdGroup
        };
        this.selectedRows = [];

        this.loading = false;
        this.loadingMessage = 'Loading...';
        this.oncloseDialog();

        if (bulkActionFromCreatePage) {
          this.createGroupTab = true;
          this.navigateToViewGroup(this.substanceGroupData, this.createdGroup || []);
          return;
        }

        this.createGroupTab = true;
        this.isEditGroup = true;
        this.isCreateGroup = false;
        this.isUpdateGroupDetails = false;
      }, (error) => {
        this.loading = false;
        this.loadingMessage = 'Loading...';
        this.matSnackBar.dismiss();
        this.bulkUploadResultDialog = true;
        this.bulkUploadPopupError = this.getBulkUploadSaveErrorMessage(error, 'Unable to update bulk upload substances.');
        return false;
      });
    }
  }

  private mergeSubstancesForEdit(existingRows: any[], incomingRows: any[]): any[] {
    const mergedRows: any[] = Array.isArray(existingRows) ? [...existingRows] : [];
    const rowIndexByKey = new Map<string, number>();

    mergedRows.forEach((row: any, index: number) => {
      const key = this.getSubstanceMergeKey(row);
      if (key) {
        rowIndexByKey.set(key, index);
      }
    });

    (incomingRows || []).forEach((row: any) => {
      const key = this.getSubstanceMergeKey(row);
      if (!key) {
        mergedRows.push({ ...row });
        return;
      }

      if (rowIndexByKey.has(key)) {
        const existingIndex = rowIndexByKey.get(key) as number;
        const existingRow = mergedRows[existingIndex] || {};
        mergedRows[existingIndex] = {
          ...existingRow,
          ...row,
          // Keep toggle states when upload payload doesn't explicitly change them.
          notifygpc: row.notifygpc !== undefined ? row.notifygpc : existingRow.notifygpc,
          notifySers: row.notifySers !== undefined ? row.notifySers : existingRow.notifySers,
          notifySir: row.notifySir !== undefined ? row.notifySir : existingRow.notifySir
        };
      } else {
        rowIndexByKey.set(key, mergedRows.length);
        mergedRows.push({ ...row });
      }
    });

    return mergedRows;
  }

  private getSubstanceMergeKey(row: any): string {
    if (!row) {
      return '';
    }

    const sirId = String(row.sirId || row.substanceId || '').trim().toLowerCase();
    if (sirId) {
      return `sir:${sirId}`;
    }

    const pureCode = String(row.purecode || row.pureCode || '').trim().toLowerCase();
    if (pureCode) {
      return `pure:${pureCode}`;
    }

    return '';
  }

  private getBulkUploadSaveErrorMessage(error: any, fallbackMessage: string) {
    if (!error) {
      return fallbackMessage;
    }

    const apiError = error.error;
    if (typeof apiError === 'string' && apiError.trim()) {
      return apiError.trim();
    }

    if (apiError && typeof apiError.message === 'string' && apiError.message.trim()) {
      return apiError.message.trim();
    }

    if (apiError && typeof apiError.title === 'string' && apiError.title.trim()) {
      return apiError.title.trim();
    }

    if (typeof error.message === 'string' && error.message.trim()) {
      return error.message.trim();
    }

    return fallbackMessage;
  }

  getBulkInvalidRows() {
    return this.bulkUploadRows.filter(row => this.isBulkRowInvalid(row));
  }

  getBulkInvalidRowsForExport() {
    return this.getBulkInvalidRows().map((row) => {
      if (row.invalidTemplateRow) {
        return row.invalidTemplateRow;
      }
      return {
        'PURE Code': row.purecode || '',
        'SIR ID': row.sirId || '',
        'CAS #': row.cas || '',
        EINECS: '',
        CF: row.cfData || '',
        'INCI Name': row.inciName || '',
        'Substance name': row.synonyms || '',
        Comments: row.errorMessage || ''
      };
    });
  }

  getBulkInvalidExportFileName() {
    const groupNameFromForm = this.groupForm && this.groupForm.value
      ? (this.groupForm.value.GroupName || this.groupForm.value.groupName || '')
      : '';
    const groupNameFromData = this.substanceGroupData && this.substanceGroupData.groupName ? this.substanceGroupData.groupName : '';
    const rawGroupName = (groupNameFromForm || groupNameFromData || 'GroupName').toString().trim();
    const safeGroupName = this.sanitizeExportFileName(rawGroupName);
    return `${safeGroupName}_${this.getCurrentExportDateTimeToken()}`;
  }

  private getCurrentExportDateTimeToken() {
    const now = new Date();
    const year = now.getFullYear();
    const month = this.padTwoDigits(now.getMonth() + 1);
    const day = this.padTwoDigits(now.getDate());
    const hours = this.padTwoDigits(now.getHours());
    const minutes = this.padTwoDigits(now.getMinutes());
    const seconds = this.padTwoDigits(now.getSeconds());
    return `${year}${month}${day}_${hours}${minutes}${seconds}`;
  }

  private padTwoDigits(value: number) {
    return value < 10 ? `0${value}` : `${value}`;
  }

  private sanitizeExportFileName(value: string) {
    const normalized = (value || '').replace(/[\\/:*?"<>|]/g, '').trim();
    const compact = normalized.replace(/\s+/g, '_');
    return compact || 'GroupName';
  }

  resetBulkUploadState() {
    this.selectedBulkFileName = '';
    this.isBulkFileNameValid = false;
    this.showOnlyInvalidBulkRows = false;
    this.isBulkSelectAllChecked = false;
    this.bulkInvalidExportDownloaded = false;
    this.bulkUploadSummary = {
      inputCount: 0,
      validCount: 0,
      invalidCount: 0
    };
    this.bulkUploadRows = [];
    this.checkedPureCodes = [];
    this.bulkUploadStatusDialog = false;
    this.bulkUploadResultDialog = false;
    this.bulkUploadPopupError = '';
  }

  sendMailtoGPC(dataDetails: any[], pureCodesDetails: any[]) {
    let emailData = '';
    this.sentPureCodes = pureCodesDetails.toString();
    dataDetails.forEach((element: any) => {
      emailData = emailData + '\r\nPure Code:' + ' ' + element.purecode + '\r\n[SIR ID :' + ' ' + element.sirId + ']' +
        '\r\nBackbone Identity :' + ' ' + element.selectedIssueCategory.map((s: any) => s.value).toString() + '\r\n' + 'Comments : ' + ' ' + element.commentsToUser + '\r\n'
        + 'Pure Description : ' + ' ' + element.pureDescription + '\r\n';
    });
    const data = {
      NotificationGroup: 'GPC',
      Subject: null,
      EmailBody: emailData,
      ToEmailList: null,
      FromEmail: null,
      CCEmailList: null,
      EmailType: 'html',
      UPD: recipeModel.division,
      PureCodes: this.sentPureCodes,
      RequestID: 0
    };
    const apiurl = environment.APIFAsT + '/email';
    this.assessRequestRa.postData(apiurl, data).subscribe((response) => {
      if (response.message !== null) {
        this.matSnackBar.open('Email message sent to SERS team successfully', 'close', {
          duration: 5000,
          panelClass: ['success']
        });
      }
    }, (error) => {
      /* tslint:disable:no-empty */
    });
  }

  hasInvalidNotifySersInput(details: any[]): boolean {
    const rows = Array.isArray(details) ? details : [];
    return rows.length === 0;
  }

  onNotifySersSend(details: any[], pureCodes: any[], isEditFlow = false): void {
    if (!Array.isArray(details) || details.length === 0) {
      this.matSnackBar.open('Select the Pure Codes', 'close', {
        duration: 3900,
        panelClass: ['error']
      });
      return;
    }

    this.sendMailtoGPC(details, pureCodes);
    if (isEditFlow) {
      this.notifyGPCDialogEdit = false;
      return;
    }
    this.notifyGPCDialog = false;
  }
  /* istanbul ignore next */
  notifySIRClicked(event: any) {
    this.sentPureCodes = this.checkedPureCodes.toString();
    if (this.checkedPureCodes.length !== 0) {
      const data = {
        NotificationGroup: 'SIR',
        Subject: null,
        EmailBody: null,
        ToEmailList: null,
        FromEmail: null,
        CCEmailList: null,
        EmailType: 'PlainText',
        UPD: recipeModel.division,
        PureCodes: this.sentPureCodes,
        RequestID: recipeModel.requestDisplayID
      };
      const apiurl = environment.APIFAsT + '/email';
      this.assessRequestRa.postData(apiurl, data).subscribe((response) => {
        if (response.message !== null) {
          this.matSnackBar.open('Email message sent to SIR team successfully', 'close', {
            duration: 3000,
            panelClass: ['success']
          });
        }
      }, (error) => {
        /* tslint:disable:no-empty */
      });
    } else {
      this.matSnackBar.open('Select the Pure Codes', 'close', {
        duration: 3900,
        panelClass: ['error']
      });
    }
  }
  /* istanbul ignore next */
  showGroup() {
    this.editLaunchedFromView = false;
    this.editViewBackContext = null;
    this.loadingMessage = 'Getting Regulatory Group Master Details';
    this.division = this.resolveActiveDivision();
    this.groupForm.controls.GroupName.setValue('');
    this.addSubstanceDialogue = false;
    this.createGroupTab = false;
    this.groupData = [];
    this.getGroups(true, true);
    this.searchIdentifier = null;
    this.searchIdentifierValue = null;
    this.searchResultsGroup = [];
    this.disablePureCode = false;
    this.getUserBasedDivision();
    this.radioRowIndex = null;
    this.selectedRowData = [];
    this.createdGroup = [];
    this.isUpdateGroupDetails = false;
    this.switchedPureCodesEdit = [];
  }

  handleEditBack(dtGroupTable: any) {
    if (!this.editLaunchedFromView) {
      this.showGroup();
      this.onClearFilters(dtGroupTable);
      return;
    }

    const backContext = this.editViewBackContext || {};
    const divisionFromBack = backContext && backContext.division
      ? String(backContext.division)
      : String(this.division || this.getSelectedDivisionName() || '');
    const cachedGroupMasterData = Array.isArray(backContext.groupMasterData) ? backContext.groupMasterData : [];
    const cachedGroupData = Array.isArray(backContext.groupData) ? backContext.groupData : [];

    this.createGroupTab = false;
    this.addSubstanceDialogue = false;
    this.isUpdateGroupDetails = false;
    this.isEditGroup = false;
    this.isCreateGroup = false;
    this.radioRowIndex = null;
    this.selectedRowData = [];

    if (divisionFromBack) {
      this.division = divisionFromBack;
      this.selectedDivision = this.buildDivisionSelection(divisionFromBack);
      this.groupForm.patchValue({
        UPDFullText: divisionFromBack,
        selectedDivision: this.selectedDivision
      });
      this.getGroupData();
      this.isGroupName = false;
      this.viewRuleBtnDisableFlag = false;
    }

    if (cachedGroupMasterData.length > 0) {
      this.groupMasterData = this.buildDateFilterTextForGroups(cachedGroupMasterData);
      this.groupData = [...cachedGroupData];
      this.disableLoader = false;
    }

    if (dtGroupTable) {
      dtGroupTable.reset();
    }
    this.resetGroupListFilters();

    // Show loader immediately while fetching fresh data from API
    this.getGroups(true, true);
    this.editLaunchedFromView = false;
    this.editViewBackContext = null;
  }

  private padDateFilterNumber(value: number): string {
    return value < 10 ? `0${value}` : String(value);
  }

  private formatGroupDateFilterText(value: any): string {
    if (value === undefined || value === null || value === '') {
      return '';
    }

    const dateValue = new Date(value);
    if (Number.isNaN(dateValue.getTime())) {
      return '';
    }

    const day = this.padDateFilterNumber(dateValue.getDate());
    const month = this.padDateFilterNumber(dateValue.getMonth() + 1);
    const year = dateValue.getFullYear();
    const hours = this.padDateFilterNumber(dateValue.getHours());
    const minutes = this.padDateFilterNumber(dateValue.getMinutes());

    return `${day}-${month}-${year}, ${hours}:${minutes}`;
  }

  private buildDateFilterTextForGroups(rows: any[]): any[] {
    return (Array.isArray(rows) ? rows : []).map((row: any) => ({
      ...row,
      createdDateFilterText: this.formatGroupDateFilterText(row && row.createdDate),
      modifiedDateFilterText: this.formatGroupDateFilterText(row && row.modifiedDate)
    }));
  }

  private getGroupFilterField(field: string): string {
    if (field === 'createdDate') {
      return 'createdDateFilterText';
    }

    if (field === 'modifiedDate') {
      return 'modifiedDateFilterText';
    }

    return field;
  }

  onGroupColumnFilter(value: any, field: string, dtGroupTable: any) {
    const filterField = this.getGroupFilterField(field);
    dtGroupTable.filter(value, filterField, 'contains');
  }

  getGroupColumnFilterValue(dtGroupTable: any, field: string) {
    const filterField = this.getGroupFilterField(field);
    const filterMeta = dtGroupTable && dtGroupTable.filters ? dtGroupTable.filters[filterField] : null;
    return filterMeta && filterMeta.value !== undefined && filterMeta.value !== null ? filterMeta.value : '';
  }

  private resolveActiveDivision() {
    const selectedDivisionValue = this.getSelectedDivisionName();
    const formDivisionValue = this.groupForm && this.groupForm.controls && this.groupForm.controls.UPDFullText
      ? this.groupForm.controls.UPDFullText.value
      : '';
    const resolvedDivision = String(this.division || selectedDivisionValue || formDivisionValue || '').trim();

    if (resolvedDivision) {
      this.division = resolvedDivision;
      this.selectedDivision = this.buildDivisionSelection(resolvedDivision);
      if (this.groupForm && this.groupForm.controls) {
        this.groupForm.patchValue({
          UPDFullText: resolvedDivision,
          selectedDivision: this.selectedDivision
        });
      }
    }

    return resolvedDivision;
  }

  private getSelectedDivisionName(): string {
    if (typeof this.selectedDivision === 'string') {
      return String(this.selectedDivision || '').trim();
    }

    if (this.selectedDivision && (this.selectedDivision as any).updName) {
      return String((this.selectedDivision as any).updName || '').trim();
    }

    return '';
  }

  private clearTransientNavigationQueryParams(): void {
    const currentPath = String(this.location.path() || '').split('?')[0];
    this.location.replaceState(currentPath);
  }

  private buildDivisionSelection(divisionName: string): any {
    const normalizedDivisionName = String(divisionName || '').trim();
    if (!normalizedDivisionName) {
      return '';
    }

    const matchedDivision = (this.divisionData || []).find((item: any) =>
      item && item.updName && String(item.updName).toLowerCase() === normalizedDivisionName.toLowerCase()
    );

    return matchedDivision || { updName: normalizedDivisionName };
  }
  /* istanbul ignore next */
  addSubstance() {
  }

  getDivisonData() {
    const apiurl = environment.APIFAsT + '/upds';
    this.assessRequestRa.getData(apiurl).subscribe((response1) => {
      this.loading = false;
      this.divisionData = response1;
      if (this.division) {
        this.selectedDivision = this.buildDivisionSelection(this.division);
        this.getGroupData();
      }
    }, (error) => {
      this.loading = false;
    });
  }

  searchDivision(event: any) {
    const filteredSearchDivision = [];
    const query = String(event && event.query ? event.query : '');
    for (const value of this.divisionData) {
      if (value.updName.toLowerCase().includes(query.toLowerCase())) {
        filteredSearchDivision.push(value);
      }
    }
    this.filteredDataDivision = filteredSearchDivision;
    const currentDivision = String(this.division || this.getSelectedDivisionName() || '').toLowerCase();
    if (currentDivision !== query.toLowerCase()) {
      this.viewRuleBtnDisableFlag = true;
    }
  }

  oncloseDialog() {
    this.switchedSirDetails = [];
    this.switchedSirDetailsEdit = [];
    this.substanceAlreadyAddedMessage = '';
  }
  getGroupData() {
    const apiurl = environment.APIFAsTRule + '/rules/groups/upd/' + this.division;
    this.assessRequestRa.getData(apiurl).subscribe((response1) => {
      this.loading = false;
      this.groupsData = response1;
    }, (error) => {
      this.loading = false;
    });
  }

  searchGroup(event: any) {
    const filteredSearchGroup = [];
    const query = event.query;
    for (const value of this.groupsData) {
      if (value.groupName.toLowerCase().includes(query.toLowerCase())) {
        filteredSearchGroup.push(value);
      }
    }
    this.filteredDataGroup = filteredSearchGroup;
    if (this.group.toLowerCase() !== query.toLowerCase()) {
      this.viewRuleBtnDisableFlag = true;
    } else {
      this.viewRuleBtnDisableFlag = false;
    }
  }

  searchSubstanceIdentifier(event: any) {
    const query = String(event && event.query ? event.query : '').toLowerCase();
    const allIdentifiers = new Set<string>();

    (this.groupData || []).forEach((item: any) => {
      const sirId = item && item.substanceId ? String(item.substanceId).trim() : '';
      const pureCode = item && item.pureCode ? String(item.pureCode).trim() : '';
      const cas = item && item.cas ? String(item.cas).trim() : '';
      const substanceName = item && item.substanceName ? String(item.substanceName).trim() : '';
      if (sirId) {
        allIdentifiers.add(sirId);
      }
      if (pureCode) {
        allIdentifiers.add(pureCode);
      }
      if (cas) {
        allIdentifiers.add(cas);
      }
      if (substanceName) {
        allIdentifiers.add(substanceName);
      }
    });

    this.filteredSubstanceIdentifiers = Array.from(allIdentifiers)
      .filter((value) => !query || value.toLowerCase().includes(query))
      .slice(0, 100);
  }

  divisionSelected(val: any): void {
    const selectedDivisionName = String(
      val && val.updName ? val.updName
      : val && val.value && val.value.updName ? val.value.updName
      : val && val.item && val.item.updName ? val.item.updName
      : val && typeof val === 'string' ? val
      : ''
    ).trim();

    this.division = selectedDivisionName;
    this.selectedDivision = this.buildDivisionSelection(selectedDivisionName);
    if (this.division !== '') {
      this.isGroupName = false;
      this.viewRuleBtnDisableFlag = false;
      this.getGroupData();
      this.group = '';
      this.selectedGroup = '';
      this.masterSubstanceIdentifier = '';
      this.filteredSubstanceIdentifiers = [];
      this.groupForm.patchValue({
        UPDFullText: selectedDivisionName,
        selectedDivision: this.selectedDivision
      });
      recipeModel.division = selectedDivisionName as any;
    } else {
      this.viewRuleBtnDisableFlag = true;
    }
  }
  groupSelected(val: any) {
    this.group = val.groupName;
    this.masterSubstanceIdentifier = '';
    this.filteredSubstanceIdentifiers = [];
    val.groupNam = '';
    if (this.group !== '') {
      this.viewRuleBtnDisableFlag = false;
    } else {
      this.viewRuleBtnDisableFlag = true;
    }
    if (this.division === '') { this.viewRuleBtnDisableFlag = true; }
  }
  viewResult(dtGroupTable: any) {
    dtGroupTable.reset();
    this.showGroup();

  }
  clearDivision() {
    this.isGroupName = true;
    this.selectedDivision = null;
    this.selectedGroup = '';
    this.groupMasterData = [];
    this.division = '';
    this.group = '';
    this.masterSubstanceIdentifier = '';
    this.filteredSubstanceIdentifiers = [];
    this.viewRuleBtnDisableFlag = true;
    this.isGroupSelected = false;
    if (this.dtGroupTable) {
      this.dtGroupTable.reset();
    }
    if (this.groupForm && this.groupForm.controls) {
      this.groupForm.patchValue({
        UPDFullText: '',
        selectedDivision: ''
      });
    }
  }
  clearGroups() {
    this.group = '';
    this.selectedGroup = '';
    this.masterSubstanceIdentifier = '';
    this.filteredSubstanceIdentifiers = [];
    this.viewRuleBtnDisableFlag = false;
    if (this.division === '') { this.viewRuleBtnDisableFlag = true; }
  }
  // get groups data for selected division
  /* istanbul ignore next */
  getGroups(showLoader = true, immediateLoader = false) {
    let loaderTimer: any = null;
    if (showLoader) {
      if (immediateLoader) {
        this.loading = true;
      } else {
        // Avoid blocking UI for fast responses; show loader only when request is slow.
        loaderTimer = setTimeout(() => {
          this.loading = true;
        }, 350);
      }
    }
    this.isGroupSelected = false;
    this.radioRowIndex = null;
    const filterText = (this.masterSubstanceIdentifier || '').trim().toLowerCase();
    this.division = this.resolveActiveDivision();
    if (!this.division) {
      if (loaderTimer) {
        clearTimeout(loaderTimer);
      }
      if (showLoader) {
        this.loading = false;
      }
      this.groupData = [];
      this.groupMasterData = [];
      this.disableLoader = true;
      return;
    }

    let apiurl = environment.APIFAsTRule + '/rules/substancegroups/masterlist/getgroupsbyfilters'
      + '?UPDFullText=' + encodeURIComponent(this.division)
      + '&GroupType=' + encodeURIComponent('Regulatory Group');
    if (this.group && this.group !== '' && this.group !== 'All') {
      apiurl += '&GroupName=' + encodeURIComponent(this.group);
    }
    if (filterText) {
      apiurl += '&SubstanceIdentifier=' + encodeURIComponent(filterText);
    }
    this.assessRequestRa.getData(apiurl).subscribe((response: any) => {
      if (loaderTimer) {
        clearTimeout(loaderTimer);
        loaderTimer = null;
      }

      const groupedRows: any[] = [];
      const groupedMasterData: any[] = [];
      const responseList = Array.isArray(response) ? response : [];

      if (responseList.length > 0) {
        const firstUpdId = responseList[0] && responseList[0].updid;
        this.updId = firstUpdId !== undefined && firstUpdId !== null ? String(firstUpdId) : '';
        this.disableLoader = false;

        const filteredResponse = responseList;

        filteredResponse.forEach((group: any) => {
          const groupSubstanceRows: any[] = [];
          const substanceIds = new Set(
            (Array.isArray(group && group.substanceIds) ? group.substanceIds : [])
              .map((id: any) => String(id || '').trim().toLowerCase())
              .filter((id: string) => !!id)
          );
          const substances = this.getGroupSubstanceRows(group);

          substances.forEach((element: any) => {
            const substanceId = element && element.sirId ? element.sirId : '';
            const normalizedSubstanceId = String(substanceId || '').trim().toLowerCase();
            const isLinkedSubstance = substanceIds.size === 0
              || !normalizedSubstanceId
              || substanceIds.has(normalizedSubstanceId);

            if (!isLinkedSubstance) {
              return;
            }

            const cfDetails = Array.isArray(element && element.cfDetails) ? element.cfDetails : [];
            const cfData = cfDetails
              .map((cf: any) => cf && cf.cfDisplayText ? cf.cfDisplayText : '')
              .filter((text: string) => !!text)
              .toString();

            const row = {
              groupId: group.groupId,
              groupName: group.groupName,
              groupType: group.groupType,
              substanceId,
              pureCode: element.pureCode,
              substanceName: element.substanceName,
              cas: element.cas,
              parentCAS: element.parentCAS,
              cfInput: (typeof element.cfInputData === 'string' && element.cfInputData) ? element.cfInputData : (typeof element.cfInput === 'string' && element.cfInput) ? element.cfInput : (cfDetails.length > 0 ? cfDetails.map((cf: any) => cf.cfDisplayText).filter((t: string) => !!t).join(', ') : ''),
              cfData,
              cfDetails,
              ins: element.ins,
              inciName: element.inciName,
              einecs: element.einecs,
              createdDate: group.createdDate,
              createdByUserIdDisplayName: group.createdByUserIdDisplayName,
              modifiedDate: group.modifiedDate,
              modifiedByUserIdDisplayName: group.modifiedByUserIdDisplayName
            };

            groupedRows.push(row);
            groupSubstanceRows.push(row);
          });

          if (groupSubstanceRows.length > 0 || substances.length === 0) {
            groupedMasterData.push({
              groupId: group.groupId,
              groupName: group.groupName,
              groupType: group.groupType,
              createdDate: group.createdDate,
              createdByUserIdDisplayName: group.createdByUserIdDisplayName,
              modifiedDate: group.modifiedDate,
              modifiedByUserIdDisplayName: group.modifiedByUserIdDisplayName,
              substancesList: groupSubstanceRows
            });
          }
        });

        this.groupData = groupedRows;
        this.groupMasterData = this.buildDateFilterTextForGroups(groupedMasterData);
        this.disableLoader = groupedMasterData.length === 0;
      } else {
        this.groupData = [];
        this.groupMasterData = [];
        this.disableLoader = true;
      }

      if (showLoader) {
        this.loading = false;
      }
    }, (error) => {
      if (loaderTimer) {
        clearTimeout(loaderTimer);
      }
      if (showLoader) {
        this.loading = false;
      }
      if (error.status === 200) {
        this.matSnackBar.open('Group data recieved', 'close', {
          duration: 3000,
          panelClass: ['success']
        });
      } else {
        this.matSnackBar.open('Request Failed', 'close', {
          duration: 3000,
          panelClass: ['error']
        });
        return false;
      }
    });
  }

  private getGroupSubstanceRows(group: any): any[] {
    const preferredKeys = ['substances', 'substanceData', 'substanceList', 'Substances', 'items', 'results', 'data'];
    for (const key of preferredKeys) {
      if (Array.isArray(group && group[key])) {
        return group[key];
      }
    }
    return [];
  }
  // To create group
  /* istanbul ignore next */
  saveGroupDetails() {
    let apiurl;
    let data;
    const selectedSubstances = this.searchedSubstanceData.filter(x => x.isSubstanceChecked && !x.sirId.includes('SIR ID Not found'));
    if (selectedSubstances.length === 0) {
      return;
    }
    this.loading = true;
    // if - Create group, Else - Edit group
    if (!this.isEditGroup && this.createdGroup.length === 0) {
      this.loadingMessage = 'Saving Group';
      apiurl = environment.APIFAsTRule + '/rules/substancegroup';
      this.groupToCreateData = this.groupForm.value;
      this.groupToCreateData.SubstanceIds = [];
      selectedSubstances.forEach(element => {
        if (!element.sirId.includes('SIR ID Not found')) {
          this.groupToCreateData.SubstanceIds.push(element.sirId);
        }
      });
      data = this.groupToCreateData;
      this.assessRequestRa.postData(apiurl, data).subscribe((response) => {
        this.matSnackBar.open('Group created successfully', 'close', {
          duration: 3000,
          panelClass: ['success']
        });
        this.isEditGroup = false;
        this.isCreateGroup = true;
        this.isUpdateGroupDetails = false;
        this.oncloseDialog();
        this.substanceGroupData = {
          groupId: response.groupId,
          groupName: response.groupName,
          groupType: response.groupType,
          substanceData: selectedSubstances
        };
        this.createdGroup = selectedSubstances;
        this.loading = false;
        this.loadingMessage = 'Loading...';
        this.substanceData = this.searchedSubstanceData;
        this.addSubstanceDialogue = false;
        this.searchedSubstanceData = [];
        this.searchedSubstanceDataTemp = [];
        this.searchIdentifierValue = '';
        this.searchResultsGroup = [];
        this.disablePureCode = false;
        this.searchIdentifier = '';
        this.isEditGroup = false;
        this.isCreateGroup = true;
        this.isUpdateGroupDetails = false;
      }, (error) => {
        this.loading = false;
        this.loadingMessage = 'Loading...';
        // Dismiss any existing snackbars to show error only in dialog
        this.matSnackBar.dismiss();
        // Extract error message from API response
        let errorMsg = 'Error saving substances';
        if (error && error.error && error.error.message) {
          errorMsg = error.error.message;
        } else if (error && error.message) {
          errorMsg = error.message;
        }
        this.substanceAlreadyAddedMessage = errorMsg;
        // Keep dialog open to show error message
        this.addSubstanceDialogue = true;
        return false;
      });
    } else {
      this.loadingMessage = 'Updating Group';
      apiurl = environment.APIFAsTRule + '/rules/editsubstancegroup';
      this.groupToEditData = Object.assign({}, this.substanceGroupData);
      this.groupToEditData.SubstanceIds = [];
      selectedSubstances.forEach(element => {
        if (!element.sirId.includes('SIR ID Not found')) {
          this.groupToEditData.SubstanceIds.push(element.sirId);
        }
      });
      data = this.groupToEditData;
      this.assessRequestRa.putData(apiurl, data).subscribe((response) => {
        this.matSnackBar.open('Group updated successfully', 'close', {
          duration: 3000,
          panelClass: ['success']
        });
        const mergedUpdatedRows = this.mergeSubstancesForEdit(this.createdGroup || [], selectedSubstances || []);
        this.createdGroup = mergedUpdatedRows;
        this.substanceGroupData = {
          ...(this.substanceGroupData || {}),
          substanceData: mergedUpdatedRows
        };
        this.selectedRows = [];
        this.loading = false;
        this.loadingMessage = 'Loading...';
        this.oncloseDialog();
        this.substanceData = this.searchedSubstanceData;
        this.addSubstanceDialogue = false;
        this.searchedSubstanceData = [];
        this.searchedSubstanceDataTemp = [];
        this.searchIdentifierValue = '';
        this.searchResultsGroup = [];
        this.disablePureCode = false;
        this.searchIdentifier = '';
      }, (error) => {
        this.loading = false;
        this.loadingMessage = 'Loading...';
        // Dismiss any existing snackbars to show error only in dialog
        this.matSnackBar.dismiss();
        // Extract error message from API response
        let errorMsg = 'Error updating substances';
        if (error && error.error && error.error.message) {
          errorMsg = error.error.message;
        } else if (error && error.message) {
          errorMsg = error.message;
        }
        this.substanceAlreadyAddedMessage = errorMsg;
        // Keep dialog open to show error message
        this.addSubstanceDialogue = true;
        return false;
      });
    }
  }


  // to search the substance on the basis of pure code
  /* istanbul ignore next */
  searchSubstance() {
    let apiurl;
    this.searchResultsGroup = [];
    let val = '';
    if (this.searchIdentifier === 'CAS #') {
      val = 'CAS';
    } else if (this.searchIdentifier === 'Substance Name') {
      val = 'BACKBONEIDENTITY';
     }  else if (this.searchIdentifier === 'INCI Name') {
      val = 'INCI';
    } else if (this.searchIdentifier === 'SIR ID') {
      val = 'SIRID';
    } else if (this.searchIdentifier === 'Pure Code') {
      val = 'PURECODE';
    }
    apiurl = environment.APIFAsTRule + '/rules/substances/' + val + '/cfRequired/y?domainRequired=yes';
    const data = [];
    data.push(this.searchIdentifierValue);
    this.loadingMessage = 'Loading...';
    this.loading = true;
    this.assessRequestRa.postData(apiurl, data).subscribe((response) => {
      if (response && response.length > 0) {
        this.substanceAlreadyAddedMessage = '';
        this.searchResultsGroup = response;
        this.loading = false;
        this.disablePureCode = true;
      }
    }, (error) => {
      this.searchResultsGroup = [];
      this.loading = false;
    });
  }

  onSearchIdentifierChange() {
    this.searchIdentifierValue = null;
    this.searchResultsGroup = [];
    this.disablePureCode = false;
  }
  // save/edit group validation check flag - enable if substances are selected
  onSubstanceSelect() {
    let sirIDExists = false;
    let displayableCount = 0;
    let checkedCount = 0;

    for (const value of this.searchedSubstanceData) {
      const sirId = String(value && value.sirId ? value.sirId : '');
      if (!sirId.includes('SIR ID Not found')) {
        sirIDExists = true;
        displayableCount++;
        if (value.isSubstanceChecked) {
          checkedCount++;
        }
      }
    }
    const selectedSubs = this.searchedSubstanceData.filter(x => x.isSubstanceChecked);
    if (selectedSubs.length > 0 && sirIDExists) {
      this.isSubstanceSelected = true;
    } else {
      this.isSubstanceSelected = false;
    }

    this.isAllSubstanceChecked = displayableCount > 0 && checkedCount === displayableCount;
  }

  onAllSubstanceSelect(event?: any) {
    const isChecked = event && event.target && typeof event.target.checked === 'boolean'
      ? event.target.checked
      : !!this.isAllSubstanceChecked;

    this.isAllSubstanceChecked = isChecked;
    this.searchedSubstanceData.forEach(x => {
      const sirId = String(x && x.sirId ? x.sirId : '');
      if (!sirId.includes('SIR ID Not found')) {
        x.isSubstanceChecked = isChecked;
      }
    });
    this.onSubstanceSelect();
  }
  // assign groupdatamodel on group selection
  onGroupSelect(event: any, rowValue: any, index: any) {
    this.radioRowIndex = index;
    this.isGroupSelected = true;
    this.substanceGroupData = {
      groupId: rowValue.groupId,
      groupName: rowValue.groupName,
      groupType: rowValue.groupType,
      substanceData: []
    };
    const sourceSubstances = Array.isArray(rowValue && rowValue.substancesList)
      ? rowValue.substancesList
      : this.groupData.filter((groupsub: any) => groupsub.groupId === rowValue.groupId);

    sourceSubstances.forEach((groupsub: any) => {
      if (groupsub.groupId === rowValue.groupId && groupsub.substanceName) {
        const subData = {
          sirId: groupsub.substanceId,
          purecode: groupsub.pureCode,
          substanceName: this.changeToTitleCase(groupsub.substanceName),
          cas: groupsub.cas,
          parentCAS: groupsub.parentCAS,
          inciName: groupsub.inciName,
          ins: groupsub.ins,
          cfInput: groupsub.cfInput || groupsub.cfinput || groupsub.cfInputData || '',
          cfDetails: groupsub.cfDetails,
          cfdata: groupsub.cfData,
          notifygpc: this.normalizeBooleanFlag(groupsub.notifygpc !== undefined ? groupsub.notifygpc : groupsub.notifySers !== undefined ? groupsub.notifySers : groupsub.notifyGpc),
          notifySers: this.normalizeBooleanFlag(groupsub.notifySers !== undefined ? groupsub.notifySers : groupsub.notifygpc !== undefined ? groupsub.notifygpc : groupsub.notifyGpc),
          einecs: groupsub.einecs,
          synonyms: groupsub.substanceName,
          createdbyuser: groupsub.createdByUserIdDisplayName
        };
        this.substanceGroupData.substanceData.push(subData);
      }
    });
    Object.assign(groupDataModel, this.substanceGroupData);
    this.dataServiceObj.setSelectedGroup(this.substanceGroupData);
  }

  changeToTitleCase(word: string) {
    if (!word) {
      return word;
    }
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }

  private fetchAndEditGroup(rowData: any) {
    const groupId = String(rowData && rowData.groupId ? rowData.groupId : '').trim();
    const groupType = String(rowData && rowData.groupType ? rowData.groupType : 'Regulatory Group').trim();
    const division = String(this.division || 'BPC').trim();

    if (!groupId || !division) {
      return;
    }

    this.loading = true;
    this.loadingMessage = 'Getting Regulatory Group Master Details';

    const buildApiUrl = (id: string, type: string, upd: string) => {
      return environment.APIFAsTRule
        + '/rules/substancegroup/masterlist/viewgroup/'
        + encodeURIComponent(upd)
        + '/'
        + encodeURIComponent(type)
        + '/'
        + encodeURIComponent(id);
    };

    const extractRows = (response: any): any[] => {
      if (!response) {
        return [];
      }
      if (Array.isArray(response)) {
        const flattenedRows: any[] = [];
        const preferredKeys = ['substanceData', 'substances', 'data', 'items', 'results', 'result', 'payload', 'response'];
        response.forEach((item: any) => {
          if (!item) {
            return;
          }
          let nestedFound = false;
          preferredKeys.forEach((key) => {
            if (!nestedFound && Array.isArray(item[key])) {
              flattenedRows.push(...item[key]);
              nestedFound = true;
            }
          });
          if (!nestedFound) {
            flattenedRows.push(item);
          }
        });
        return flattenedRows;
      }

      const preferredTopKeys = ['substanceData', 'substances', 'data', 'items', 'results', 'result', 'payload', 'response'];
      for (const key of preferredTopKeys) {
        if (Array.isArray(response[key])) {
          return response[key];
        }
      }
      return [];
    };

    const mapEditRows = (rows: any[]) => {
      return rows.map((row: any) => {
        const source = row && row.substance ? row.substance : row;
        return {
          sirId: source.sirId || source.substanceId || '',
          purecode: source.pureCode || source.purecode || '',
          substanceName: this.changeToTitleCase(source.substanceName || source.synonyms || ''),
          cas: source.cas || '',
          parentCAS: source.parentCAS || source.parentCas || '',
          inciName: source.inciName || '',
          ins: source.ins || '',
          cfInput: source.cfInput || source.cfInputData || source.CFInputData || '',
          cfDetails: Array.isArray(source.cfDetails) ? source.cfDetails : [],
          cfdata: source.cfData || source.cfdata || source.CFDataFromSIR || source.cfDataFromSIR || '',
          notifygpc: this.normalizeBooleanFlag(source.notifygpc !== undefined ? source.notifygpc : source.notifySers !== undefined ? source.notifySers : source.notifyGpc),
          notifySers: this.normalizeBooleanFlag(source.notifySers !== undefined ? source.notifySers : source.notifygpc !== undefined ? source.notifygpc : source.notifyGpc),
          einecs: source.einecs || '',
          synonyms: source.synonyms || source.substanceName || '',
          createdbyuser: source.createdByUserIdDisplayName || ''
        };
      });
    };

    const apiurl = buildApiUrl(groupId, groupType, division);
    this.assessRequestRa.getData(apiurl).subscribe((response: any) => {
      const rows = extractRows(response);
      if (rows.length > 0) {
        const mappedRows = mapEditRows(rows);
        this.substanceGroupData.substanceData = mappedRows;
        this.createdGroup = mappedRows;
        this.loading = false;
        // Reset substance table filters when loading new group data
        if (this.dtSubstanceTable) {
          this.dtSubstanceTable.reset();
        }
        return;
      }

      // Fallback: try without spaces in groupType
      const compactGroupType = groupType.replace(/\s+/g, '');
      if (compactGroupType && compactGroupType !== groupType) {
        const fallbackUrl = buildApiUrl(groupId, compactGroupType, division);
        this.assessRequestRa.getData(fallbackUrl).subscribe((fallbackResponse: any) => {
          const fallbackRows = extractRows(fallbackResponse);
          const mappedRows = mapEditRows(fallbackRows);
          this.substanceGroupData.substanceData = mappedRows;
          this.createdGroup = mappedRows;
          this.loading = false;
          // Reset substance table filters when loading new group data
          if (this.dtSubstanceTable) {
            this.dtSubstanceTable.reset();
          }
        }, () => {
          this.loading = false;
        });
        return;
      }

      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  /* istanbul ignore next */
  editGroup() {
    this.getUserBasedDivision();
    this.isEditbtnDisable = true;
    this.selectedRows = [];
    this.switchedPureCodesEdit = [];
    this.switchedSirDetailsEdit = [];
    this.createGroupTab = true;
    this.addSubstanceDialogue = false;
    this.isEditGroup = true;
    this.isCreateGroup = false;
    this.groupForm = this.formBuilder.group({
      GroupName: this.substanceGroupData.groupName,
      GroupType: 'Regulatory Group',
      UPDFullText: this.division,
      SubstanceIds: [],
      selectedDivision: this.buildDivisionSelection(this.division),
    });
    this.createdGroup = this.substanceGroupData.substanceData;
    this.userDetails = JSON.parse(localStorage.getItem('userRolesPermissions') || '{}');
    if (this.substanceGroupData.substanceData && this.substanceGroupData.substanceData.length > 0
      && this.substanceGroupData.substanceData[0].createdbyuser === this.userDetails.userDisplayName) {
      this.isUserAuthToEditGrpName = true;
    } else {
      this.getUserBasedDivision();
    }
    const ele = document.getElementById('echeck') as HTMLInputElement;
    if (ele) {
      ele.checked = false;
    }
    // Reset substance table filters when entering edit mode
    if (this.dtSubstanceTable) {
      this.dtSubstanceTable.reset();
    }
  }

  get isDeleteGroupCommentValid(): boolean {
    return !noWhitespaceValidator({ value: this.deleteGroupComment } as AbstractControl);
  }

  /* istanbul ignore next */
  deleteGroup() {
    this.loading = true;
    this.loadingMessage = 'Deleting Regulatory Group - ' + this.substanceGroupData.groupId;
    const apiUrl = environment.APIFAsTRule + '/rules/substancegroup/' + this.substanceGroupData.groupId + '/comments/' + this.deleteGroupComment;
    this.assessRequestRa.deleteData(apiUrl).subscribe((response) => {
      if (response) {
        this.loading = false;
        this.deleteGroupResponse = response.message;
        if (response.message.startsWith('Deleted')) {
          this.deleteGroupResponseSuccess = true;
          this.deleteGroupResponse = 'No associated rules found. Group deletion successful.';
        }
      }
    }, (error) => {
      this.loading = false;
    });
    this.removeBtn = true;
  }
  closePopup() {
    this.deleteGroupPopup = false;
    this.enableDelete = false;
    this.showGroup();
  }
  closeGroupConfPopup() {
    this.deleteGroupConfPopup = false;
  }
  rowselected(data: any) {
    this.onGroupSelect(data, data.data, data.index);
  }
  editGrpDetails() {
    const currentGroupName = String(this.groupForm && this.groupForm.controls && this.groupForm.controls.GroupName
      ? this.groupForm.controls.GroupName.value
      : '').trim();
    const existingGroupName = String(this.substanceGroupData && this.substanceGroupData.groupName
      ? this.substanceGroupData.groupName
      : '').trim();
    this.originalEditGroupName = currentGroupName || existingGroupName;

    this.isEditGroup = false;
    this.isUpdateGroupDetails = true;
  }

  private restoreGroupNameIfCleared() {
    const currentGroupName = String(this.groupForm && this.groupForm.controls && this.groupForm.controls.GroupName
      ? this.groupForm.controls.GroupName.value
      : '').trim();
    const fallbackGroupName = String(this.originalEditGroupName || '').trim();

    if (!currentGroupName && fallbackGroupName && this.groupForm && this.groupForm.controls) {
      this.groupForm.patchValue({
        GroupName: fallbackGroupName
      });
      if (this.substanceGroupData) {
        this.substanceGroupData.groupName = fallbackGroupName;
      }
    }
  }

  onRenameGroupNo() {
    this.restoreGroupNameIfCleared();
    this.editGroupPopup = false;
  }

  cancelGroupNameEdit() {
    this.restoreGroupNameIfCleared();
    this.isUpdateGroupDetails = false;
    this.isEditGroup = true;
    this.isCreateGroup = false;
  }
  /* istanbul ignore next */
  editGroupDetails() {
    this.loading = true;
    this.loadingMessage = 'Updating Regulatory Group - ' + this.substanceGroupData.groupId;
    const apiUrl = environment.APIFAsTRule + '/rules/substancegroup/' + this.substanceGroupData.groupId + '/comments/' + this.deleteGroupComment;
    this.assessRequestRa.deleteData(apiUrl).subscribe((response) => {
      if (response) {
        this.loading = false;
        this.deleteGroupResponse = response.message;
        if (response.message.startsWith('Deleted')) {
          this.deleteGroupResponseSuccess = true;
        }
      }
    }, (error) => {
      this.loading = false;
    });
    this.removeBtn = true;
  }
  onRowUnselect(event: any) {
    this.radioRowIndex = null;
    this.isGroupSelected = false;
  }
  /* istanbul ignore next */
  addItem() {
    this.searchedSubstanceData = this.searchedSubstanceData.concat(this.searchedSubstanceDataTemp);

    if (this.isAllSubstanceChecked) {
      this.searchedSubstanceData.forEach((item: any) => {
        if (item && item.sirId && !item.sirId.includes('SIR ID Not found')) {
          item.isSubstanceChecked = true;
        }
      });
    }

    this.searchedSubstanceDataTemp = [];
    this.addItemBtnDisableFlag = true;
    this.disablePureCode = false;
    this.onSubstanceSelect();
  }
  /* istanbul ignore next */
  valueSelected(rowselected: any, event: any) {
    if (event.currentTarget.checked) {
      let purecode: any;
      let sirId: any;
      let cas: any;
      let parentCAS: any;
      let cfdata: any;
      let einecs: any;
      let synonyms: any;
      let ins: any;
      let inciName: any;
      let sirIdNotFound: any;
      let existingRecord: any;
      this.checkSelectedVal = rowselected.sirId + ' (' + rowselected.substanceName + ')';
      if (rowselected) {
        const found = this.searchedSubstanceData.some(item => item.sirId === rowselected.sirId);
        if (found) {
          this.substanceAlreadyAddedMessage = 'Substance already added';
          this.loading = false;
          return false;
        }
        this.loading = false;
        const sirvalues = rowselected;
        purecode = sirvalues.pureCode;
        sirId = sirvalues.sirId;
        if (!sirId || sirId === '' || sirId.includes('SIR ID Not found')) {
          sirIdNotFound = true;
        } else {
          sirIdNotFound = false;
        }
        cas = sirvalues.cas;
        parentCAS = sirvalues.parentCAS;
        einecs = sirvalues.einecs;
        synonyms = sirvalues.substanceName;
        if (sirvalues.cfDetails !== null) {
          cfdata = sirvalues.cfDetails[0].cfDisplayText;
        }
        ins = sirvalues.ins;
        inciName = sirvalues.inciName;
        existingRecord = this.searchedSubstanceDataTemp.filter(x => x.sirId === sirId);
        if (this.isEditGroup === true) {
          existingRecord = this.substanceGroupData.substanceData.filter((x: any) => x.sirId === sirId);
        }
        if (existingRecord && existingRecord.length > 0) {
          this.substanceAlreadyAddedMessage = 'Substance already added.';
          this.loading = false;
          return false;
        }

        this.searchedSubstanceDataTemp.push({
          purecode,
          sirId,
          cas,
          parentCAS,
          einecs,
          synonyms,
          cfdata,
          ins,
          inciName,
          isSubstanceChecked: true,
          sirIdNotFound
        });
        this.loading = false;
      } else if (this.searchIdentifier === 'Pure Code') {
        this.loading = false;
        existingRecord = this.searchedSubstanceDataTemp.filter(x => x.purecode === this.searchIdentifierValue);
        if (existingRecord && existingRecord.length > 0) {
          this.matSnackBar.open('Duplicate Record', 'close', {
            duration: 6000,
            panelClass: ['error']
          });
          return false;
        }
        purecode = this.searchIdentifierValue;
        const foundPure = this.searchedSubstanceData.some(item => item.purecode === rowselected.purecode);
        if (!foundPure) {
          this.searchedSubstanceDataTemp.push({
            purecode,
            isSubstanceChecked: false,
            sirIdNotFound: true
          });
        }

      } else {
        this.loading = false;
        this.matSnackBar.open('Could not find a matching substance, Please provide the correct search value', 'close', {
          duration: 6000,
          panelClass: ['error']
        });
      }

    } else {
      this.searchedSubstanceDataTemp = this.searchedSubstanceDataTemp.filter((item) => item.sirId !== rowselected.sirId);
    }
    if (this.searchedSubstanceDataTemp.length > 0) {
      this.addItemBtnDisableFlag = false;
    } else {
      this.addItemBtnDisableFlag = true;
    }
  }
  checkval(event: any) {
    if (event.target.value === '') {
      this.searchResultsGroup = [];
      this.disablePureCode = false;
    } else {
      this.addItemBtnDisableFlag = true;
    }
    setTimeout(() => {
      if (event.target.value !== this.checkSelectedVal) {
        this.searchResultsGroup = [];
        this.disablePureCode = false;
      }
    }, 1000);
  }

  createGroupFormStructure() {
    const normalizedDivision = this.division || this.getSelectedDivisionName();
    this.groupForm = this.formBuilder.group({
      GroupName: ['', [Validators.required, noWhitespaceValidator]],
      GroupType: 'Regulatory Group',
      UPDFullText: normalizedDivision,
      selectedDivision: this.buildDivisionSelection(normalizedDivision),
      SubstanceIds: [],
    });
  }
    /* istanbul ignore next */
    removeDuplicates(array: any[], ruleID: string) {
      const lookup: { [key: string]: any } = {};
      array.forEach((element: any) => {
        lookup[element[ruleID]] = element;
      });
      return Object.keys(lookup).map(prop => lookup[prop]);
    }

  notifyGPCClicked(event: any, selectedSirDetails: any[]) {
    this.substanceAlreadyAddedMessage = '';
    for (const value of selectedSirDetails) {
      value.selectedIssueCategory = [];
      value.commentsToUser = '';
    }
    selectedSirDetails = this.removeDuplicates(selectedSirDetails, 'sirId');
    this.selectedSirDetails = selectedSirDetails;
    this.notifyGPCDialog = true;
  }
  notifyGPCClickedEdit(event: any, selectedSirDetails: any[]) {
    this.substanceAlreadyAddedMessage = '';
    for (const value of selectedSirDetails) {
      value.selectedIssueCategory = [];
      value.commentsToUser = '';
    }
    const dedupedSelectedSirDetails = this.removeDuplicates(selectedSirDetails, 'sirId');
    this.selectedSirDetails = dedupedSelectedSirDetails;
    this.selectedSirDetailsEdit = dedupedSelectedSirDetails;
    this.notifyGPCDialogEdit = true;
  }

  private syncEditNotifySelections() {
    const selectedRows = this.getSelectedEditNotifyRows();
    this.switchedSirDetailsEdit = selectedRows;
    this.switchedPureCodesEdit = selectedRows
      .map((row: any) => row.purecode)
      .filter((value: string) => !!value);
  }

  getSelectedEditNotifyRows(): any[] {
    return (this.createdGroup || []).filter((row: any) => !!row.notifygpc);
  }

  getSelectedEditNotifyCount(): number {
    return this.getSelectedEditNotifyRows().length;
  }

  handleSwitchEdit(event: any, sirvalue: any) {
    this.editNotifyGPC = true;
    sirvalue.issueCategoryList = [
      { name: 'CAS#', value: 'CAS#' },
      { name: 'Parent CAS#', value: 'Parent CAS#' },
      { name: 'E#', value: 'E#' },
      { name: 'INS#', value: 'INS#' },
      { name: 'EINECS#', value: 'EINECS#' },
      { name: 'INCI', value: 'INCI' },
      { name: 'Synonym', value: 'Synonym' },
      { name: 'CF details', value: 'CF details' },
    ];
    sirvalue.selectedIssueCategory = [];
    const isChecked = event && typeof event.checked === 'boolean' ? event.checked : !!sirvalue.notifygpc;
    sirvalue.notifygpc = isChecked;
    this.syncEditNotifySelections();
  }
  handleSwitch(event: any, sirvalue: any) {
    sirvalue.issueCategoryList = [
      { name: 'CAS#', value: 'CAS#' },
      { name: 'Parent CAS#', value: 'Parent CAS#' },
      { name: 'E#', value: 'E#' },
      { name: 'INS#', value: 'INS#' },
      { name: 'EINECS#', value: 'EINECS#' },
      { name: 'INCI', value: 'INCI' },
      { name: 'Synonym', value: 'Synonym' },
      { name: 'CF details', value: 'CF details' },
    ];
    sirvalue.selectedIssueCategory = [];
    if (event.checked === true) {
      this.switchedSirDetails.push(sirvalue);
      this.switchedPureCodes.push(sirvalue.purecode);
    } else if (event.checked === false) {
      const index = this.switchedPureCodes.findIndex(d => d === sirvalue.purecode);
      this.switchedPureCodes.splice(index, 1);
      this.switchedSirDetails.splice(index, 1);
    }
  }

  onCheck(event: any, checkedPureCode: string) {
    if (event.checked === true) {
      this.checkedPureCodes.push(checkedPureCode);
    } else if (event.checked === false) {
      const index = this.checkedPureCodes.findIndex(d => d === checkedPureCode);
      this.checkedPureCodes.splice(index, 1);
    }
  }
  /* istanbul ignore next */
  checkRulesAvail() {
    this.loading = true;
    this.selectedRowsEmail = [];
    this.showRelatedRequests = false;
    this.getUserBasedDivision();
    this.selectedRowWorklist = null;
    this.loadingMessage = 'Fetching data from FAsT Rule-Engine';
    const sirIds: string[] = [];
    this.selectedRows.forEach((element: any) => {
      sirIds.push(element.sirId);
    });
    const body = {
      GroupID: this.substanceGroupData.groupId,
      GroupSubstances: sirIds
    };
    const apiUrl = environment.APIFAsTRule + '/rules/substancegroups/relatedrules/View/rulestatus/' + 'activeandfutureactive';
    this.assessRequestRa.postData(apiUrl, body).subscribe((response) => {
      this.showRelatedRulesPopup = true;
      this.loading = false;
      this.deleteRulePopup = false;
      if (response.length > 0) {
        this.prepareRuleTableData = this.assessRequestRa.modifyObjectForTableMapping(response);
      } else {
        this.prepareRuleTableData = response;
      }
      for (const val of this.prepareRuleTableData) {
        val.warningText = (val.warningText !== null && val.warningText !== '') ? val.warningText : ((val.warningStatement !== null) ? val.warningStatement : '');
        val.originalWarningText = val.warningText;
        const warningLinkRuleData = this.assessRequestRa.hyperLinksToSheet(val.warningText);
        val.warningText1 = warningLinkRuleData[0] !== undefined ? warningLinkRuleData[0] : '';
        val.warningText2 = warningLinkRuleData[1] !== undefined ? warningLinkRuleData[1] : '';
        val.warningText3 = warningLinkRuleData[2] !== undefined ? warningLinkRuleData[2] : '';
        val.warningText4 = warningLinkRuleData[3] !== undefined ? warningLinkRuleData[3] : '';
        val.warningText5 = warningLinkRuleData[4] !== undefined ? warningLinkRuleData[4] : '';
        val.warningText6 = warningLinkRuleData[5] !== undefined ? warningLinkRuleData[5] : '';
        val.warningText7 = warningLinkRuleData[6] !== undefined ? warningLinkRuleData[6] : '';
        val.warningTextStripped = this.handleSpecialCharacters(val.warningText);
        val.warningText = this.changeComment(val.warningText);
        val.otherRestrictionsAndRequirements = (val.otherRestrictionsAndRequirements !== null) ? val.otherRestrictionsAndRequirements : '';
        const orrLinkRuleData = this.assessRequestRa.hyperLinksToSheet(val.otherRestrictionsAndRequirements);
        val.ORR1 = orrLinkRuleData[0] !== undefined ? orrLinkRuleData[0] : '';
        val.ORR2 = orrLinkRuleData[1] !== undefined ? orrLinkRuleData[1] : '';
        val.ORR3 = orrLinkRuleData[2] !== undefined ? orrLinkRuleData[2] : '';
        val.ORR4 = orrLinkRuleData[3] !== undefined ? orrLinkRuleData[3] : '';
        val.ORR5 = orrLinkRuleData[4] !== undefined ? orrLinkRuleData[4] : '';
        val.ORR6 = orrLinkRuleData[5] !== undefined ? orrLinkRuleData[5] : '';
        val.ORR7 = orrLinkRuleData[6] !== undefined ? orrLinkRuleData[6] : '';
        val.otherRestrictionsAndRequirementsStripped = this.handleSpecialCharacters(val.otherRestrictionsAndRequirements);
        val.originalotherRestrictionsAndReq = val.otherRestrictionsAndRequirements;
        val.otherRestrictionsAndRequirements = this.changeComment(val.otherRestrictionsAndRequirements);
      }
      setTimeout(() => {
        const element = document.getElementById('echeckdel') as HTMLInputElement;
        if (element) {
          element.checked = false;
        }
        if (this.selectedRows.length === this.createdGroup.length) {
          this.matSnackBar.open('Atleast one Purecode must be available in the substance group', 'close', {
            duration: 3900,
            panelClass: ['error']
          });
        }
      }, 500);
    }, (error) => {
      this.loading = false;
    });
    if (this.substanceGroupData.substanceData[0].createdbyuser === this.userDetails.userDisplayName) {
      this.isUserAuthToEditGrpName = true;
    } else {
      this.getUserBasedDivision();
    }
    this.enableDelete = false;
  }
  handleSpecialCharacters(text: string) {
    return text.replace(/<.*?>/g, '').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&nbsp;.*?/gi, '').replace(/&amp;/g, '&');
  }
  /* istanbul ignore next */
  checkRulesAvailForDelete() {
    this.loading = true;
    this.showRelatedRequests = false;
    this.selectedRowWorklist = null;
    this.selectedRowsEmail = [];
    this.enableDelete = false;
    this.loadingMessage = 'Fetching data from FAsT Rule-Engine';
    const sirIds: string[] = [];
    this.substanceGroupData.substanceData.forEach((element: any) => {
      sirIds.push(element.sirId);
    });
    const body = {
      GroupID: this.substanceGroupData.groupId,
      GroupSubstances: sirIds
    };
    const apiUrl = environment.APIFAsTRule + '/rules/substancegroups/relatedrules/View/rulestatus/' + 'all';
    this.assessRequestRa.postData(apiUrl, body).subscribe((response) => {
      this.showRelatedRulesPopupForDelete = true;
      this.loading = false;
      this.deleteRulePopup = false;
      if (response.length > 0) {
        this.prepareRuleTableData = this.assessRequestRa.modifyObjectForTableMapping(response);
      } else {
        this.prepareRuleTableData = response;
      }
      for (const val of this.prepareRuleTableData) {
        val.warningText = (val.warningText !== null && val.warningText !== '') ? val.warningText : ((val.warningStatement !== null) ? val.warningStatement : '');
        val.originalWarningText = val.warningText;
        const warningLinkRuleData = this.assessRequestRa.hyperLinksToSheet(val.warningText);
        val.warningText1 = warningLinkRuleData[0] !== undefined ? warningLinkRuleData[0] : '';
        val.warningText2 = warningLinkRuleData[1] !== undefined ? warningLinkRuleData[1] : '';
        val.warningText3 = warningLinkRuleData[2] !== undefined ? warningLinkRuleData[2] : '';
        val.warningText4 = warningLinkRuleData[3] !== undefined ? warningLinkRuleData[3] : '';
        val.warningText5 = warningLinkRuleData[4] !== undefined ? warningLinkRuleData[4] : '';
        val.warningText6 = warningLinkRuleData[5] !== undefined ? warningLinkRuleData[5] : '';
        val.warningText7 = warningLinkRuleData[6] !== undefined ? warningLinkRuleData[6] : '';
        val.warningTextStripped = this.handleSpecialCharacters(val.warningText);
        val.warningText = this.changeComment(val.warningText);
        val.otherRestrictionsAndRequirements = (val.otherRestrictionsAndRequirements !== null) ? val.otherRestrictionsAndRequirements : '';
        val.originalotherRestrictionsAndReq = val.otherRestrictionsAndRequirements;
        val.otherRestrictionsAndRequirementsStripped = this.handleSpecialCharacters(val.otherRestrictionsAndRequirements);
        const orrLinkRuleData = this.assessRequestRa.hyperLinksToSheet(val.otherRestrictionsAndRequirements);
        val.ORR1 = orrLinkRuleData[0] !== undefined ? orrLinkRuleData[0] : '';
        val.ORR2 = orrLinkRuleData[1] !== undefined ? orrLinkRuleData[1] : '';
        val.ORR3 = orrLinkRuleData[2] !== undefined ? orrLinkRuleData[2] : '';
        val.ORR4 = orrLinkRuleData[3] !== undefined ? orrLinkRuleData[3] : '';
        val.ORR5 = orrLinkRuleData[4] !== undefined ? orrLinkRuleData[4] : '';
        val.ORR6 = orrLinkRuleData[5] !== undefined ? orrLinkRuleData[5] : '';
        val.ORR7 = orrLinkRuleData[6] !== undefined ? orrLinkRuleData[6] : '';
        val.otherRestrictionsAndRequirements = this.changeComment(val.otherRestrictionsAndRequirements);
      }
      setTimeout(() => {
        const element = document.getElementById('echeckdel') as HTMLInputElement;
        if (element) {
          element.checked = false;
        }
      }, 500);
    }, (error) => {
      this.loading = false;
    });
  }

  selectRow(checkValue: boolean) {
    const isChecked = !!checkValue;
    (this.createdGroup || []).forEach((row: any) => {
      row.isEditRowChecked = isChecked;
    });
    this.selectedRows = isChecked ? (this.createdGroup || []).slice() : [];
    this.isEditSelectAllChecked = isChecked;
  }

  onEditRowSelectionChange() {
    const totalRows = (this.createdGroup || []).length;
    this.selectedRows = (this.createdGroup || []).filter((row: any) => !!row.isEditRowChecked);
    const selectedRowsCount = this.selectedRows.length;
    this.isEditSelectAllChecked = totalRows > 0 && selectedRowsCount === totalRows;
  }

  selectRowEmail(checkValue: boolean) {
    if (checkValue) {
      this.selectedRowsEmail = this.workListData;
    } else {
      this.selectedRowsEmail = [];
    }
  }

  deleteRequests() {
    this.loading = true;
    this.loadingMessage = 'Deleting...';
    const sirIds: string[] = [];
    this.selectedRows.forEach((element: any) => {
      sirIds.push(element.sirId);
    });
    const body = {
      GroupID: this.substanceGroupData.groupId,
      GroupSubstances: sirIds
    };
    const apiUrl = environment.APIFAsTRule + '/rules/substancegroups/relatedrules/Delete/rulestatus/activeandfutureactive';
    this.assessRequestRa.postData(apiUrl, body).subscribe((response) => {
      if (response) {
        this.selectedRows.forEach((elements: any) => {
          this.substanceGroupData.substanceData = this.substanceGroupData.substanceData.filter((x: any) => x.sirId !== elements.sirId);
        });
        this.createdGroup = _.xor(this.createdGroup, this.selectedRows);
        this.showRelatedRulesPopup = false;
        this.deleteRulePopup = false;
        this.loading = false;
        this.selectedRows = [];
        this.matSnackBar.open('Deleted successfully', 'close', {
          duration: 3000,
          panelClass: ['success']
        });
        const ele = document.getElementById('echeck') as HTMLInputElement;
        if (ele) {
          ele.checked = false;
        }
        const element = document.getElementById('echeckdel') as HTMLInputElement;
        if (element) {
          element.checked = false;
        }
      }
    }, (error) => {
      this.loading = false;
    });
  }

  sendEmail() {
    this.showEmailConfirmationDialog = true;
    this.emailComments = '';
  }

  deleteGroupConfirmation() {
    this.getUserBasedDivision();
    if (this.isSuperAdminOrGlobalRA) {
    this.deleteGroupPopup = true;
    this.enableDelete = true;
    this.deleteGroupComment = '';
    this.deleteGroupResponse = '';
    this.removeBtn = false;
    this.deleteGroupResponseSuccess = false;
     } else {
    this.deleteGroupConfPopup = true;
    this.loading = false;
     }
  }
  /* istanbul ignore next */
  updateGroupConfirmation() {
    this.getUserBasedDivision();
    if (this.substanceGroupData.substanceData[0].createdbyuser === this.userDetails.userDisplayName) {
      this.isUserAuthToEditGrpName = true;
    } else {
      this.getUserBasedDivision();
    }
    if (this.isUserAuthToEditGrpName) {
      this.editGroupPopup = true;
    } else {
      this.editGroupPopup = false;
      this.matSnackBar.open('User is not authorised to rename the group for [' + this.division + ']  division', 'close', {
        duration: 6000,
        panelClass: ['error']
      });
    }
  }
  /* istanbul ignore next */
  editGroupConfirmation() {
    const groupNameValue = this.groupForm.controls.GroupName.value;
    if (!groupNameValue || !String(groupNameValue).trim()) {
      this.matSnackBar.open('Group Name field should not be empty', 'close', {
        duration: 3000,
        panelClass: ['error']
      });
      return;
    }

    const updatedGroupName = String(groupNameValue).trim();

    this.loading = true;
    this.loadingMessage = 'Updating Group';
    const apiUrl = environment.APIFAsTRule + '/rules/updategroup';
    let data1;
    this.groupToEditData = Object.assign({}, this.substanceGroupData);
    this.groupToEditData.groupName = updatedGroupName;
    this.groupToEditData.UPDFullText = this.division;
    data1 = this.groupToEditData;
    this.assessRequestRa.putData(apiUrl, data1).subscribe((response) => {
      if (response) {
        const responseGroupName = response && response.groupName ? String(response.groupName).trim() : '';
        const retainedGroupName = responseGroupName || updatedGroupName;

        this.substanceGroupData = {
          ...(this.substanceGroupData || {}),
          groupName: retainedGroupName
        };
        this.groupForm.patchValue({
          GroupName: retainedGroupName
        });
        this.originalEditGroupName = retainedGroupName;
        this.group = retainedGroupName;

        this.groupMasterData = (this.groupMasterData || []).map((row: any) => {
          if (String(row && row.groupId) === String(this.substanceGroupData && this.substanceGroupData.groupId)) {
            return {
              ...row,
              groupName: retainedGroupName
            };
          }
          return row;
        });
        this.groupData = (this.groupData || []).map((row: any) => {
          if (String(row && row.groupId) === String(this.substanceGroupData && this.substanceGroupData.groupId)) {
            return {
              ...row,
              groupName: retainedGroupName
            };
          }
          return row;
        });

        this.isUpdateGroupDetails = true;
        this.matSnackBar.open('Updated successfully', 'close', {
          duration: 3000,
          panelClass: ['success']
        });
        this.isEditGroup = true;
        this.isCreateGroup = false;
        this.loading = false;
        this.editGroupPopup = false;
        this.isUpdateGroupDetails = false;
      }
    }, (error) => {
      this.loading = false;
    });
  }
  /* istanbul ignore next */
  sendEmailMessage() {
    this.showEmailConfirmationDialog = false;
    if (!this.selectedRowWorklist) {
      return;
    }
    const payLoad: any = {
      NotificationGroup: 'RDCOMPLETED',
      Subject: 'FAsT | Rules updated for these requests :',
      EmailBody: null,
      ToEmailList: '',
      FromEmail: null,
      CCEmailList: null,
      EmailType: 'html',
      UPD: this.selectedRowWorklist.ruleId.toString(),
      PureCodes: null,
      UserRequests: [],
      CUCDescription: null,
      Comments: this.emailComments
    };

    if (this.selectedRowsEmail.length > 0) {
      this.selectedRowsEmail.forEach((row: any) => {
        const reqIds = this.selectedRowsEmail.filter((item: any) => item.submittedByUserId === row.submittedByUserId).map((i: any) => i.requestDisplayID);
        payLoad.UserRequests.push({
          userId: +row.submittedByUserId,
          requestIds: reqIds
        });
      });
    }

    if (payLoad.UserRequests.length > 0) {
      this.assessRequestRa.sendRulesEmailNotification(payLoad);
    }
  }

  getWorklistColumns() {
    const apiurl = environment.APIFAsT + '/getworklistcolumns/relatedrequest';
    this.worklistService.getWorklistApiData(apiurl).subscribe((response) => {
      this.myWorklistTableColumns = response;
    });
  }

  onRowSelectReq(value: any) {
    this.workListData = [];
    this.selectedRowWorklist = value;
    this.loadingMessage = 'Fetching data from FAsT Rule-Engine';
    this.loading = true;
    const apiurl = environment.APIFAsTRule + '/rules/queryrelatedrequests';
    const body = [];
    body.push({
      RuleId: value.ruleId,
      RuleVersion: value.ruleVersion
    });
    this.assessRequestRa.postData(apiurl, body).subscribe((response) => {
      if (response) {
        this.showRelatedRequests = true;
        this.loading = false;
        this.workListData = response.map((respElem: any) => {
          return {
            requestDisplayID: respElem.requestDisplayID,
            cucCode: respElem.cucCode,
            cucDescription: respElem.cucDescription,
            recipeType: respElem.recipeType,
            recipeStatus: respElem.recipeStatus,
            marketId: respElem.market.marketId,
            marketName: respElem.market.marketName,
            division: (respElem.tfc.tfcLevel === 5) ? respElem.tfc.parentTFC.parentTFC.parentTFC.parentTFC.tfcName : respElem.tfc.parentTFC.parentTFC.parentTFC.tfcName,
            rDFormulationCategory: (respElem.tfc.tfcLevel === 5) ? respElem.tfc.parentTFC.parentTFC.parentTFC.tfcName : respElem.tfc.parentTFC.parentTFC.tfcName,
            formulationType: (respElem.tfc.tfcLevel === 5) ? respElem.tfc.parentTFC.parentTFC.tfcName : respElem.tfc.parentTFC.tfcName,
            formulationClass: (respElem.tfc.tfcLevel === 5) ? respElem.tfc.parentTFC.tfcName : respElem.tfc.tfcName,
            formulationSubClass: (respElem.tfc.tfcLevel === 5) ? respElem.tfc.tfcName : '',
            preparationMethod: respElem.preparationMethod,
            intendedUse: respElem.intendedUse,
            multicomponent: respElem.isMultiComponent,
            requestStatus: respElem.requestStatus,
            ra: respElem.ra,
            allRa: respElem.allRA,
            submittedDate: respElem.submittedDate,
            submittedByUserId: respElem.submittedByUserId,
            submittedByUserName: respElem.submittedByUserName,
            comments: respElem.comments,
            assignedDate: respElem.assignedDate,
            inProgressRADate: respElem.inProgressRADate,
            inProgressRDDate: respElem.inProgressRNDDate,
            inProgressSIRDate: respElem.inProgressSIRDate,
            rejectedDate: respElem.rejectedDate,
            deletionDate: respElem.deletionDate,
            completedDate: respElem.completedDate,
            rdComment: respElem.comments,
            raComment: respElem.raComment,
            topTfcId: respElem.tfcid,
            allRAIDs: respElem.allRAIDs,
            raUserID: respElem.raUserIDred,
            divisionid: (respElem.tfc.tfcLevel === 5) ? respElem.tfc.parentTFC.parentTFC.parentTFC.parentTFC.tfcId : respElem.tfc.parentTFC.parentTFC.parentTFC.tfcId
          };
        });
      }
    }, (error) => {
      this.loading = false;
    });
  }

  selectRowForDelete(checked: boolean) {
    if (checked) {
      this.enableDelete = true;
    } else {
      this.enableDelete = false;
    }
  }

  deleteRule() {
    this.deleteRulePopup = true;
    this.deleteRuleComment = '';
  }

  showExportDialog() {
    const hasTableFilters = this.dtGroupTable && this.dtGroupTable.filters
      ? Object.keys(this.dtGroupTable.filters).some((key: string) => {
          const filterMeta = this.dtGroupTable.filters[key];
          return filterMeta && filterMeta.value !== undefined && filterMeta.value !== null && String(filterMeta.value).trim() !== '';
        })
      : false;
    const hasSmartSearchFilters = !!String(this.group || '').trim() || !!String(this.masterSubstanceIdentifier || '').trim();

    if (this.dtGroupTable && Array.isArray(this.dtGroupTable.filteredValue) && hasTableFilters) {
      this.filteredRows = this.dtGroupTable.filteredValue;
    } else if (hasSmartSearchFilters) {
      this.filteredRows = Array.isArray(this.groupMasterData) ? this.groupMasterData : [];
    } else {
      this.filteredRows = [];
    }

    this.exportDialog = true;
  }

  onFilter(event: any) {
    this.filteredRows = event.filteredValue;
  }

  onEditSubstanceColumnFilter(value: string, field: string, dtSubstanceTable: any) {
    if (!dtSubstanceTable) {
      return;
    }

    if (field !== 'notifygpc') {
      dtSubstanceTable.filter(value, field, 'contains');
      return;
    }

    const normalized = String(value || '').trim().toLowerCase();
    if (!normalized) {
      dtSubstanceTable.filter(null, field, 'equals');
      return;
    }

    if (normalized === 'true') {
      dtSubstanceTable.filter(true, field, 'equals');
      return;
    }

    if (normalized === 'false') {
      dtSubstanceTable.filter(false, field, 'equals');
      return;
    }

    // For partial/invalid boolean text, do not force-match true/false.
    dtSubstanceTable.filter(null, field, 'equals');
  }

  /* istanbul ignore next */
  onClearFilters(dtGroupTable: any) {
    dtGroupTable.reset();
    this.resetGroupListFilters();
    this.group = '';
    this.selectedGroup = '';
    this.masterSubstanceIdentifier = '';
    this.filteredSubstanceIdentifiers = [];
  }
  showOverlay(htmlContent: any) {
    this.overlayText = htmlContent;
    this.hideOverlay = false;
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }
  hideOverlayPanel() {
    this.hideOverlay = true;
  }
  popupShowOverlay(htmlContent: any) {
    this.popupOverlayText = htmlContent;
    this.popupHideOverlay = false;
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }
  popupHideOverlayPanel() {
    this.popupHideOverlay = true;
  }
    /* istanbul ignore next */
    openComment(data: any) {
      this.warningTextOpen = true;
      const mydata = data.originalWarningText;
      this.tablewarningComment = mydata.replace(new RegExp('<a', 'g'), '<a target="_blank"');
    }
      /* istanbul ignore next */
      openCommentORR(data: any) {
      this.orrTextOpen = true;
      const mydata = data.originalotherRestrictionsAndReq;
      this.tableORRComment = mydata.replace(/<a/gi, '<a target="_blank"');
    }
    closePopupORR() {
      this.orrTextOpen = false;
    }
    closePopupW() {
      this.warningTextOpen = false;
    }
    /* istanbul ignore next */
    changeComment(input: any) {
      const strValue = input;
      const ar = strValue.match(/<a.*?<\/a>/g);
      let commentwarning = '';
      if ((ar !== null) && (ar.length === 0 || ar.length > 0)) {
        commentwarning = 'Click Here';
      } else {
        commentwarning = input;
      }
      return commentwarning;
    }
}
function compareData(a: any, b: any) {
  return a.groupId - b.groupId;
}
